<template>
  <div class="home">
    <header class="header" v-show="cardStatus !== '进入布局'"
      :style="{ 'pointer-events': cardStatus === '布局预览' ? 'none' : 'auto' }">
      <div class="header-inner">
        <div class="warning" @click="toggleProductView('WarningStat')">
          <img v-for="(item, index) in alarmArr" :key="index" :src="require(`@/assets/images/alarmicon/${item.signame}${item.siglevel}.gif`)
            " />
        </div>
        <div class="logo">
          <span class="company-name">{{ companyName }}</span>
          <div class="sys-name-main">
            <img class="icon" src="../assets/images/左2.png" /><span class="sys-name">{{ subname }}</span><img
              class="icon" src="../assets/images/右2.png" />
          </div>
        </div>
        <div class="sys_logo" v-if="sysLogo">
          <img :src="sysLogo" />
        </div>
        <div class="header-right">
          <div class="menu">
            <div class="menu-item">
              <el-tooltip class="item" effect="dark" content="决策看板" placement="top">
                <img src="../assets/images/地理信息.png" />
                <div class="select-map" slot="content">
                  <div class="title">地图</div>
                  <div class="item" @click="selectMap(item, index)" v-for="(item, index) in maps" :key="index + ''">
                    <span><i class="el-icon-check" v-show="mapType === item"></i></span>
                    <span>{{ item }}</span>
                  </div>

                  <div class="title">辅助信息</div>
                  <div class="item" @click="selectMap('经纬线')">
                    <span><i class="el-icon-check" v-show="fuzhuTypes.includes('经纬线')"></i></span>
                    <span>经纬线</span>
                  </div>
                  <!-- <div class="item"
                    @click="warnState = !warnState;warnLayer.setVisible(warnState); ">
                    <span><i class="el-icon-check" v-show="warnState"></i></span>
                    <span>警戒圈</span>
                  </div> -->
                  <div class="item" @click="selectMap('测距')">
                    <span><i class="el-icon-check" v-show="fuzhuTypes.includes('测距')"></i></span>
                    <span>测距</span>
                  </div>
                </div>
              </el-tooltip>
            </div>
            <div class="line"></div>
            <div class="menu-item" v-show="isjc === 1">
              <el-tooltip class="item" effect="dark" content="决策服务" placement="top">
                <img src="../assets/images/servicePanel.png" @click="goToService" />
              </el-tooltip>
            </div>
            <div class="line" v-show="isjc === 1"></div>

            <!--            <div class="menu-item">-->
            <!--              <el-tooltip class="item" effect="dark" content="决策看板" placement="top">-->
            <!--                <img src="../assets/images/监控数据.png" @click="goToDataCenter" />-->
            <!--              </el-tooltip>-->
            <!--            </div>-->
            <!--            <div class="line"></div>-->
            <!--            <div class="menu-item">-->
            <!--              <el-tooltip class="item" effect="dark" content="天气咨询：400234456" placement="top">-->
            <!--                <img src="../assets/images/电话.png"/>-->
            <!--              </el-tooltip>-->
            <!--            </div>-->
            <!--            <div class="line"></div>-->
            <!--            <div class="menu-item">-->
            <!--              <el-tooltip class="item" effect="dark" content="帮助" placement="top">-->
            <!--                <img src="../assets/images/帮助.png"/>-->
            <!--              </el-tooltip>-->
            <!--            </div>-->
            <!--            <div class="line"></div>-->
            <div class="menu-item" @click="toggleProductView('Config')">
              <el-tooltip class="item" effect="dark" content="设置" placement="top">
                <img src="../assets/images/设置.png" />
              </el-tooltip>
            </div>
            <div class="line"></div>
            <div class="menu-item" @click="logout">
              <el-tooltip class="item" effect="dark" content="退出" placement="top">
                <img src="../assets/images/退出.png" />
              </el-tooltip>
            </div>
            <div class="line line1"></div>
          </div>
          <div class="now" v-show="cardStatus !== '布局预览'">
            <strong>{{ time }}</strong>
            <span>{{ day }}</span>
          </div>
          <div class="back-btn" v-show="cardStatus === '布局预览'" @click="cardStatus = '进入布局'">
            <img src="../assets/images/返回.png" alt="" />
            返回布局
          </div>
        </div>
      </div>

      <div class="right-top-tool">
        <div class="top-wrap" ref="topWrapRef">
          <div class="top-cont">
            <div :class="{
              image: true,
              active: selectRightTopData.includes(item.code),
            }" v-for="(item, index) in rightTopData" v-show="item.isshow === 1 && item.isdy === 1" :key="index"
              @click="tabItemClick('right-top', index, item)">
              <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                <img v-if="item.imgbase" :src="'data:image/jpg;base64,' + item.imgbase" alt="" />
                <span v-else>{{ item.name }}</span>
              </el-tooltip>
            </div>

            <div :class="{
              image: true,
              active: cardShow,
            }" @click="isShowCard">
              <el-tooltip class="item" effect="dark" content="一键清屏" placement="top">
                <img src="@/assets/images/clear.png" alt="" />
                <!-- <img  src="@/assets/images/cla.png" alt="" /> -->
              </el-tooltip>
            </div>
          </div>
        </div>

        <!-- <img class="right-btn" src="../assets/images/右1.png" alt="" @click="moveTopRightTool"> -->
      </div>

      <div class="left-top-tool">
        <!--        <div class="message-item" @click="-->
        <!--          toggleProductView('UnitRisk') &&-->
        <!--          $bus.$emit('showRisk') &&-->
        <!--          clearAnimation('riskFrist')-->
        <!--          ">-->
        <!--          <i :class="{-->
        <!--            risk: true,-->
        <!--            animation: newestUnitRisk.length > 0 && riskFrist,-->
        <!--          }"></i>-->
        <!--          <span>【风险提醒】{{-->
        <!--              newestUnitRisk.length > 0 ? newestUnitRisk[0].info : '无'-->
        <!--            }}</span>-->
        <!--        </div>-->
        <div class="message-item" @click="
          toggleProductView('UnitInsure') &&
          $bus.$emit('showInsure') &&
          clearAnimation('riskFrist')
          " v-if="
            (labelid === 1 || labelid === 4) &&
            bxIndexRecordResult &&
            companyName !== '佛山地铁'
          ">
          <i :class="{
            risk: true,
            animation: bxIndexRecordResult.length > 0 && riskFrist,
          }">
          </i>
          <div v-if="bxIndexRecordResult.length > 0" class="risk_count" :class="{
            animation: bxIndexRecordResult.length > 0 && riskFrist,
          }">
            {{ bxIndexRecordResult.length }}
          </div>
          <span>
            【理赔提醒】
            {{
              bxIndexRecordResult.length > 0
                ? bxIndexRecordResult[0].objname +
                " " +
                bxIndexRecordResult[0].bxname
                : "无"
            }}</span>
        </div>
        <div class="message-item" v-show="companyName !== '佛山地铁'"
          @click="toggleProductView('NewRemind') && clearAnimation('newRFrist')">
          <i :class="{ weather: true, animation: tqtxShow && newRFrist }"></i>
          <span>{{
            tqtxShow ? captureTxMsg(newestTxMsg[0].cont) : "【天气提醒】无"
          }}</span>
        </div>
        <!--        <div class="message-item" @click="-->
        <!--          toggleProductView('NewWeatherReport') && clearAnimation('newZFrist')-->
        <!--          ">-->
        <!--          <i :class="{ report: true, animation: zhuanbaoShow && newZFrist }"></i>-->
        <!--          <span>{{-->
        <!--              zhuanbaoShow-->
        <!--                ? '【专报提醒】' + newestZhuanBao[0].influence-->
        <!--                : '【专报提醒】无'-->
        <!--            }}</span>-->
        <!--        </div>-->
      </div>
    </header>

    <div class="obt-ptime" v-show="selectRightTopData.includes('A05') ||
      selectRightTopData.includes('A06') ||
      selectRightTopData.includes('A07') ||
      selectRightTopData.includes('A08')
      ">
      数据时间： {{ $moment(obtPTime).format("YYYY年MM月DD日 HH时mm分") }}
    </div>

    <div class="right-bottom-tool">
      <div :class="{ image: true, active: item.select }" v-for="(item, index) in rightBottomData" :key="index"
        @click="tabItemClick('right-bottom', index)">
        <img :src="item.src" alt="" :class="{ reset_index: index === 3 }" />
      </div>
    </div>

    <div class="center-bottom-tool">
      <img src="../assets/images/左1.png" class="center-control" @click="moveToolPosition('left')" alt="" />
      <div class="center-box" ref="contentBoxRef">
        <div class="content-wrap" ref="contentWrapRef">
          <div :class="{
            'nav-item': true,
            active: selectedNavs.includes(item.code),
          }" v-for="(item, index) in navs" :key="index" v-show="item.isshow === 1 && item.isdy === 1"
            @click.stop="toggleProductView(item.code, item)">
            <img :src="'data:image/png;base64,' + item.imgbase" alt="" />
            <div class="name">{{ item.name.slice(0, 4) }}</div>
          </div>
        </div>
      </div>
      <img src="../assets/images/右1.png" class="center-control" @click="moveToolPosition('right')" alt="" />
    </div>

    <div class="container">
      <aside class="aside" v-show="false">
        <nav class="nav">
          <el-scrollbar style="height: 100%">
            <ul class="menu">
              <li style="position: relative" :class="{ active: selectedNavs.includes(item.code) }" v-for="item in navs"
                :key="item.id" @click.stop="toggleProductView(item.code)">
                <span>
                  <i :style="'background: url(data:image/png;base64,' +
                    item.imgbase +
                    ') no-repeat;'
                    "></i><span>{{ item.name }}</span>
                </span>

                <span class="count" v-show="item.code === 'E1' && zbNum > 0">{{
                  zbNum
                }}</span>
              </li>
            </ul>
          </el-scrollbar>
        </nav>
      </aside>
      <div class="main">
        <div id="map"></div>
        <!-- ✅ 添加 fsmetro 路线控制面板 -->
        <div v-if="companyName === '佛山地铁' && routeOptions.length > 0" class="route-control-panel">
          <div class="route-list">
            <button v-for="item in routeOptions" :key="item.value" type="button" class="route-btn"
              :class="{ active: selectedRoutes.includes(item.value) }" :style="{ backgroundImage: `url(${item.bg})` }"
              @click="toggleRoute(item.value)">
              {{ item.label }}
            </button>
          </div>
        </div>

        <!--弹窗-->
        <component :is="item.ename" v-for="item in components" :key="item.ename" :params="item.params" ref="cpnRef">
        </component>

        <!-- 右边的三个弹框 -->
        <card1 v-if="cardStatus === '取消布局'"></card1>
        <card2 v-if="cardStatus === '取消布局'"></card2>
        <card3 v-if="cardStatus === '取消布局'"></card3>
        <card4 v-if="cardStatus === '取消布局'"></card4>
        <card5 v-if="cardStatus === '取消布局'"></card5>
        <card6 v-if="cardStatus === '取消布局'"></card6>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mark"></div>
    <card-config v-show="cardStatus !== '取消布局'"></card-config>

    <thunder-overlayer ref="thunderOverlayerRef" :thunderData="thunderData"></thunder-overlayer>
    <!-- 实时经纬度信息框 -->
    <!-- <div class="lonlatInfo">
      {{ mapLonLat }}
    </div> -->
    <!-- 地铁预警信号弹窗 组件形式吧 -->
    <metro-alert-dialog :showMetroAlertDialog.sync="showMetroAlertDialog"
      :metroAlertForecast.sync="metroAlertForecast"></metro-alert-dialog>
    <!-- 地铁预警走马灯滚动展示 -->
    <div class="metro-swiper" v-if="metroAlertText && !showMetroAlertDialog">
      <img src="../assets/images/alarmIcon.png" class="alarm-icon" alt="" />
      <div class="metro-swiper-viewport">
        <div class="metro-swiper-track" :style="{ animationDuration: metroAlertDuration }">
          <span class="metro-swiper-item">{{ metroAlertText }}</span>
          <span class="metro-swiper-item">{{ metroAlertText }}</span>
        </div>
      </div>
    </div>
    <!-- 地铁阈值告警弹窗 -->
    <real-time-alarm-dialog :showRealTimeAlarmDialog.sync="showRealTimeAlarmDialog"
      :realTimeAlarm.sync="realTimeAlarm"></real-time-alarm-dialog>
  </div>
</template>

<script>
import Card1 from "@/components/Card1.vue";
import Card2 from "@/components/Card2.vue";
import Card3 from "@/components/Card3.vue";
import Card4 from "@/components/Card4.vue";
import Card5 from "@/components/Card5.vue";
import Card6 from "@/components/Card6.vue";
import CardConfig from "@/components/CardConfig.vue";

import ThunderOverlayer from "@/components/module/overlayer/thunder-overlayer.vue";
import MetroAlertDialog from "@/components/metro-alert-dialog.vue";
import RealTimeAlarmDialog from "@/components/real-time-alarm-dialog.vue";
import Map2d from "../plugins/map2d/Main";
import MeasureTools from "../plugins/map2d/MeasureTools";
import ImageLayer from "ol/layer/Image";
import ImageStatic from "ol/source/ImageStatic";
import GeoJSON from "ol/format/GeoJSON";
import { Vector as VectorLayer } from "ol/layer";
import { Vector, Vector as VectorSource } from "ol/source";
import Feature from "ol/Feature";
import { Icon, Style, Stroke, Text, Fill } from "ol/style";
import { Point, Circle } from "ol/geom";
import { fromLonLat } from "ol/proj";
import Overlay from "ol/Overlay";
import {
  featureCollection,
  point,
  lineString,
  lengthToRadians,
} from "@turf/helpers";
import turfConvex from "@turf/convex";
import turfBuffer from "@turf/buffer";
import * as turf from "@turf/turf";

import Polygon from "ol/geom/Polygon";
import { WindLayer } from "ol-wind";
import WindBarb from "../plugins/map2d/WindBarb";
import Vue from "vue";
import { apiData, jsonData } from "../api/index";
import { mapMutations, mapState } from "vuex";
import { DoubleClickZoom } from "ol/interaction";

const baseMap = process.env.VUE_APP_BASE_MAP;
const baseMapBlue = process.env.VUE_APP_BASE_BLUE_MAP;
export default {
  name: "Home",
  data() {
    return {
      obtPTime: new Date(),
      baseUrl: process.env.VUE_APP_BASE_API,
      navs: [],
      unitObjs: [],
      labelid: -1,
      alarmArea: null,
      newestAlarms: [],
      selectedNavs: [],
      zbNum: 0, // 最新专报的数量
      center: [113.122717, 23.028762],
      sysLogo: "",
      isjc: 0,
      codesInfo: {
        A01: {
          componentName: "ImageByMap",
          group: "imageProduct",
        },
        A02: {
          componentName: "TyphoneByMap",
          group: "TyphoneByMap",
        },
        A03: {
          componentName: "Thunder",
          group: "Thunder",
        },
        A04: {
          componentName: "ImageByMap",
          group: "ImageByMap",
        },
        A11: {
          componentName: "LineForest",
          group: "LineForest",
        },
        A12: {
          componentName: "PhasedRadar",
          group: "PhasedRadar",
        },
        C01: {
          componentName: "WeatherReport",
          group: "WeatherReport",
        },
        C02: {
          componentName: "RiskRemind",
          group: "RiskRemind",
        },
        C03: {
          componentName: "Remind",
          group: "Remind",
        },
        // C04: {
        //   componentName: 'WarningHistory',
        //   group: 'WarningHistory'
        // },
        C05: {
          componentName: "LiveFactor",
          group: "LiveFactor",
        },
        C07: {
          componentName: "SelectData",
          group: "SelectData",
        },
        C08: {
          componentName: "WindBulbSignal",
          group: "WindBulbSignal",
        },
        C09: {
          componentName: "Waterlogging",
          group: "Waterlogging",
        },
        C10: {
          componentName: "Standard",
          group: "Standard",
        },
        C12: {
          componentName: "Barometer",
          group: "Barometer",
        },
        C13: {
          componentName: "ConstructionWindow",
          group: "ConstructionWindow",
        },
        C14: {
          componentName: "MonthlyWeather",
          group: "MonthlyWeather",
        },
        // C15: {
        //   componentName: 'ExtendedForecast',
        //   group: 'ExtendedForecast'
        // },
        C16: {
          componentName: "SevenDayForecast",
          group: "SevenDayForecast",
        },
        R1: {
          componentName: "RainNotification",
          group: "RainNotification",
        },
        P1: {
          componentName: "IcyRoad",
          group: "IcyRoad",
        },
        S1: {
          componentName: "WeatherFacts",
          group: "WeatherFacts",
        },
        C17: {
          componentName: "Article",
          group: "Article",
        },
        C19: {
          componentName: "HyReport",
          group: "HyReport",
        },
        A13: {
          componentName: "ImageSelectBtn",
          group: "ImageSelectBtn",
        },
      },
      options: {
        view: {
          // center: [113.580637, 23.25178],
          center: [113.122717, 23.028762],
          zoom: 11,
          maxZoom: 20,
          minZoom: 5,
          // 设置缩放级别为整数
          constrainResolution: true,
          // 关闭无极缩放
          smoothResolutionConstraint: false,
          projection: "EPSG:4326",
        },
        map: [
          {
            name: "业务图1",
            ename: "yewumap",
            url: [baseMapBlue],
            maxZoom: 13,
          },
          {
            name: "业务图2",
            ename: "yewumap2",
            url: [
              baseMap,
              // 'https://www.gzqxfw.com.cn/map/bk/{z}/{x}/{y}.jpg'
              // 'http://gzqxfw.tqyb.club/map/bk/{z}/{x}/{y}.jpg'
              // 'http://dh.runbir.com/map/mercator/base/{z}/{x}/{y}.png'
              // 'http://dh.runbir.com/map/mercator/gd_guangzhou/{z}/{x}/{y}.png'
            ],
            maxZoom: 13,
          },
          {
            name: "街道地图",
            ename: "openstreetmap",
            url: [
              "http://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=48fb1019fa26991b5831d6a97db2fc16",
              "http://t0.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=48fb1019fa26991b5831d6a97db2fc16",
            ],
            maxZoom: 18,
          },
          {
            name: "地形图",
            ename: "terrain",
            url: [
              "http://t0.tianditu.gov.cn/ter_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ter&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=48fb1019fa26991b5831d6a97db2fc16",
              "http://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=48fb1019fa26991b5831d6a97db2fc16",
            ],
            maxZoom: 18,
          },
          {
            name: "影像地图",
            ename: "MapServer",
            url: [
              "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=48fb1019fa26991b5831d6a97db2fc16",
              "http://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=48fb1019fa26991b5831d6a97db2fc16",
            ],
            maxZoom: 18,
          },
        ],
        graticule: {
          strokeColor: "#E6A23Caa",
          strokeWidth: 1,
          targetSize: 200,
        },
      },

      rightBottomData: [
        {
          src: require("../assets/images/广东省.png"),
          select: false,
        },
        {
          src: require("../assets/images/佛山市.png"),
          select: false,
        },
        {
          src: require("../assets/images/警戒圈.png"),
          select: true,
        },
        {
          src: require("../assets/images/重置地图中心.png"),
          select: true,
        },
      ],
      selectRightTopData: [],
      rightTopData: [],
      overlayer: null,
      dataPointOverlayer: null,
      zjStationDataResultOverlayer: null,
      overlayerLayers: [],
      dataPointOverlayerLayers: [],
      zjStationDataResultOverlayerLayers: [],
      alarmIcon: [],
      pointName: "",
      forecastType: 0,
      riskType: 0,
      currentHourForecast: 0,
      charts: [],
      components: [],
      day: "",
      time: "",
      interTime: null,
      companyName: "",
      subname: "",
      zhuanbaoShow: false,
      tqtxShow: false,
      maps: ["业务图1", "业务图2", "矢量图", "地形图", "影像图"],
      mapType: "业务图",
      fuzhuTypes: [],
      fuzhuType: "",
      warnState: true,
      warnLayer: "",
      riskFrist: true,
      newRFrist: true,
      newZFrist: true,
      typhoonSource: null,
      windLayer: null, // 风场
      layers: {}, // 所有的要素图层
      tableData: [],
      thunderData: {},
      cardShow: false,
      Imagelayer: "",
      jhwImagelayer: "",
      cardStatus: "取消布局", // 进入布局','布局预览,取消布局
      displayLayer: null,
      displayLayer2: null,
      maplevel: null,
      unitCenter: {},
      dataPointLayer: null,
      dataPointSource: null,
      zjPointLayer: null,
      zjPointSource: null,
      doubleClickZoomInteraction: null,
      mapLonLat: "",
      // 路线控制相关
      routeOptions: [], // 路线选项 [{ label: '显示名称', value: '路线名称', color: '颜色' }]
      selectedRoutes: [], // 选中的路线 value 数组
      routeLayers: [], // 所有路线图层
      // ✅ 点位归属映射
      stationRouteMap: {
        // ===== 有轨电车1号线点位 =====
        礌岗: "南海有轨电车1号线(林岳东--礌岗)",
        华翠路: "南海有轨电车1号线(林岳东--礌岗)",
        夏西: "南海有轨电车1号线(林岳东--礌岗)",
        夏东: "南海有轨电车1号线(林岳东--礌岗)",
        夏东康怡公园区间U型槽: "南海有轨电车1号线(林岳东--礌岗)",
        康怡公园: "南海有轨电车1号线(林岳东--礌岗)",
        "康怡—平西": "南海有轨电车1号线(林岳东--礌岗)",
        平西: "南海有轨电车1号线(林岳东--礌岗)",
        "平西—平南": "南海有轨电车1号线(林岳东--礌岗)",
        平南: "南海有轨电车1号线(林岳东--礌岗)",
        "平南—玉器街": "南海有轨电车1号线(林岳东--礌岗)",
        玉器街: "南海有轨电车1号线(林岳东--礌岗)",
        "玉器街—中区": "南海有轨电车1号线(林岳东--礌岗)",
        中区站: "南海有轨电车1号线(林岳东--礌岗)",
        "中区—三北": "南海有轨电车1号线(林岳东--礌岗)",
        三山新城北: "南海有轨电车1号线(林岳东--礌岗)",
        "三北—文翰湖": "南海有轨电车1号线(林岳东--礌岗)",
        文翰湖: "南海有轨电车1号线(林岳东--礌岗)",
        "文翰湖—三南": "南海有轨电车1号线(林岳东--礌岗)",
        三山新城南: "南海有轨电车1号线(林岳东--礌岗)",
        "三南—林岳北": "南海有轨电车1号线(林岳东--礌岗)",
        林岳北: "南海有轨电车1号线(林岳东--礌岗)",
        "林岳北—林岳西": "南海有轨电车1号线(林岳东--礌岗)",
        林岳西: "南海有轨电车1号线(林岳东--礌岗)",

        林岳东: "南海有轨电车1号线(林岳东--礌岗)",

        环岛车辆段: "南海有轨电车1号线(林岳东--礌岗)",

        // ===== 2号线点位 =====
        广州南站: "佛山地铁2号线(广州南站--南庄)",
        "林岳东(2号线)": "佛山地铁2号线(广州南站--南庄)",
        林岳西林岳东区间U型槽: "佛山地铁2号线(广州南站--南庄)",
        "林岳东—广州南": "佛山地铁2号线(广州南站--南庄)",
        石洲站: "佛山地铁2号线(广州南站--南庄)",
        "仙涌—石洲": "佛山地铁2号线(广州南站--南庄)",
        仙涌站: "佛山地铁2号线(广州南站--南庄)",
        花仙区间U型槽: "佛山地铁2号线(广州南站--南庄)",
        花卉世界站: "佛山地铁2号线(广州南站--南庄)",
        登洲站: "佛山地铁2号线(广州南站--南庄)",
        湾华站: "佛山地铁2号线(广州南站--南庄)",
        石梁站: "佛山地铁2号线(广州南站--南庄)",
        魁奇路站: "佛山地铁2号线(广州南站--南庄)",
        沙岗站: "佛山地铁2号线(广州南站--南庄)",
        石湾站: "佛山地铁2号线(广州南站--南庄)",
        张槎站: "佛山地铁2号线(广州南站--南庄)",
        智慧新城站: "佛山地铁2号线(广州南站--南庄)",
        绿岛湖站: "佛山地铁2号线(广州南站--南庄)",
        湖涌站: "佛山地铁2号线(广州南站--南庄)",
        南庄站: "佛山地铁2号线(广州南站--南庄)",
        湖涌停车场出入场线U型槽: "佛山地铁2号线(广州南站--南庄)",
        湖涌停车场: "佛山地铁2号线(广州南站--南庄)",
        石湾主所: "佛山地铁2号线(广州南站--南庄)",
        花卉主所: "佛山地铁2号线(广州南站--南庄)",
        林岳车辆段: "佛山地铁2号线(广州南站--南庄)",
        湾华控制中心: "佛山地铁2号线(广州南站--南庄)",
        "石洲—林岳西": "佛山地铁2号线(广州南站--南庄)",

        // ===== 3号线点位 =====
        佛山大学: "地铁3号线(佛山大学--顺德学院站)",
        "南海大学城-佛山大学U型槽": "地铁3号线(佛山大学--顺德学院站)",
        佛科院: "地铁3号线(佛山大学--顺德学院站)",
        南海大学城: "地铁3号线(佛山大学--顺德学院站)",
        博爱中路: "地铁3号线(佛山大学--顺德学院站)",
        科盛路: "地铁3号线(佛山大学--顺德学院站)",
        兴业东路: "地铁3号线(佛山大学--顺德学院站)",
        佛山西站: "地铁3号线(佛山大学--顺德学院站)",
        罗村: "地铁3号线(佛山大学--顺德学院站)",
        孝德东: "地铁3号线(佛山大学--顺德学院站)",
        佛山机场: "地铁3号线(佛山大学--顺德学院站)",
        联和: "地铁3号线(佛山大学--顺德学院站)",
        佛山高铁站: "地铁3号线(佛山大学--顺德学院站)",
        敦厚: "地铁3号线(佛山大学--顺德学院站)",
        中山公园: "地铁3号线(佛山大学--顺德学院站)",
        叠滘: "地铁3号线(佛山大学--顺德学院站)",
        桂城: "地铁3号线(佛山大学--顺德学院站)",
        西约: "地铁3号线(佛山大学--顺德学院站)",
        亚艺公园: "地铁3号线(佛山大学--顺德学院站)",
        湾华: "地铁3号线(佛山大学--顺德学院站)",
        东平: "地铁3号线(佛山大学--顺德学院站)",
        大墩: "地铁3号线(佛山大学--顺德学院站)",
        岳步: "地铁3号线(佛山大学--顺德学院站)",
        潭洲会展: "地铁3号线(佛山大学--顺德学院站)",
        北滘西站: "地铁3号线(佛山大学--顺德学院站)",
        高村: "地铁3号线(佛山大学--顺德学院站)",
        北滘公园: "地铁3号线(佛山大学--顺德学院站)",
        "北滘公园-广教站U型槽": "地铁3号线(佛山大学--顺德学院站)",
        广教: "地铁3号线(佛山大学--顺德学院站)",
        "伦教-广教": "地铁3号线(佛山大学--顺德学院站)",
        伦教: "地铁3号线(佛山大学--顺德学院站)",
        "荔村-伦教U型槽": "地铁3号线(佛山大学--顺德学院站)",
        荔村: "地铁3号线(佛山大学--顺德学院站)",
        顺德人民医院: "地铁3号线(佛山大学--顺德学院站)",
        环市北: "地铁3号线(佛山大学--顺德学院站)",
        大良钟楼: "地铁3号线(佛山大学--顺德学院站)",
        东乐路: "地铁3号线(佛山大学--顺德学院站)",
        驹荣北路: "地铁3号线(佛山大学--顺德学院站)",
        顺德一中: "地铁3号线(佛山大学--顺德学院站)",
        顺德欢乐海岸: "地铁3号线(佛山大学--顺德学院站)",
        顺德学院站: "地铁3号线(佛山大学--顺德学院站)",
        狮山车辆段: "地铁3号线(佛山大学--顺德学院站)",
        狮山车辆段U型槽: "地铁3号线(佛山大学--顺德学院站)",
        博爱路主所: "地铁3号线(佛山大学--顺德学院站)",
        文昌主所: "地铁3号线(佛山大学--顺德学院站)",
        岳步主所: "地铁3号线(佛山大学--顺德学院站)",
        夏园主所: "地铁3号线(佛山大学--顺德学院站)",
        北滘停车场: "地铁3号线(佛山大学--顺德学院站)",
        北滘停车场出入场线U型槽: "地铁3号线(佛山大学--顺德学院站)",
        南园: "地铁3号线(佛山大学--顺德学院站)",
        季华六路: "地铁3号线(佛山大学--顺德学院站)",
        镇安: "地铁3号线(佛山大学--顺德学院站)",
        逢沙停车场: "地铁3号线(佛山大学--顺德学院站)",
        逢沙停车场U型槽: "地铁3号线(佛山大学--顺德学院站)",
        顺德港: "地铁3号线(佛山大学--顺德学院站)",
      },
      showMetroAlertDialog: false, // 佛山地铁预警信号弹窗
      metroAlertForecast: {}, // 佛山地铁预警预报
      showRealTimeAlarmDialog: false, // 佛山地铁实况阈值告警弹窗
      realTimeAlarm: {}, // 佛山地铁实况阈值告警
      // ✅ 存储点位 feature 的引用
      stationFeatures: [],
      hiddenStationNames: [],
      lastMetroThinningZoom: null,
      metroKeyStations: [
        // 佛山地铁关键站点一直显示
        "广州南站",
        "南庄站",
        // "林岳东(2号线)",
        "林岳东",
        "礌岗",
        "佛山大学",
        "顺德学院站",
        "佛山西站",
        "佛山高铁站",
        // "佛山机场",
        "湾华站",
        "魁奇路站",
        // "桂城",
        "林岳西",
      ],
    };
  },
  watch: {
    activeCountyId() {
      // this.activeCountyId()
      this.getRightCardData();
    },
    tqskDateResult: {
      async handler() {
        await this.getGiftLive();
      },
      deep: true,
      immediate: true,
    },
    // ✅ 监听路线选中变化
    selectedRoutes: {
      handler(newVal) {
        console.log("当前点位", this.tableData);
        console.log("newVal", newVal);
        this.updateRouteVisibility();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", [
      "newestTxMsg",
      "newestZhuanBao",
      "newestUnitRisk",
      "objsList",
      "activeCountyId",
      "tqskDateResult",
      "unitPointDataResult",
      "bxIndexRecordResult",
      "unitZjStationDataResult",
      "cartData",
    ]),
    alarmArr() {
      return this.alarmArea && this.newestAlarms[this.alarmArea];
    },
    metroAlertText() {
      if (!this.metroAlertForecast || !this.metroAlertForecast.text) {
        return "";
      }
      return `${this.metroAlertForecast.text}`;
    },
    metroAlertDuration() {
      const len = this.metroAlertText.length || 20;
      return `${Math.max(12, Math.round(len * 0.25))}s`;
    },
  },
  async created() {
    this.getDate();
  },
  async mounted() {
    this.init();
    await this.listColumn();
    console.log("this.selectedNavs", this.selectedNavs);
    this.selectedNavs.forEach((element) => this.loadProduct(element));
    this.connectWebsocket();
    this.warnScope();
    document.addEventListener("contextmenu", () => {
      this.fuzhuTypes.includes("测距") && this.selectMap("测距");
    });

    this.timmer = setInterval(async () => {
      await this.getGiftLive();
      this.getRightCardData();
    }, 5000 * 60);
    const { company } = this.$route.params;
    const { unit } = JSON.parse(localStorage.getItem(company));
    const maps = ["ywmap", "ywmap2", "vectormap", "terrain", "photomap"];
    const index = maps.findIndex((item) => item === unit.defaultmap);
    this.selectMap(this.maps[index], index);
    if (unit.id === 28) {
      this.setSource();
    }
    this.listenerBusElement();
    this.addWindyLayer();
    this.queryMetroAlertForecast();
    this.queryRealTimeAlarm();
    setInterval(() => {
      this.queryMetroAlertForecast();
      this.queryRealTimeAlarm();
    }, 2000 * 60);
  },
  methods: {
    ...mapMutations("home", [
      "changeNewestZhuanBao",
      "changeNewestTxMsg",
      "changeNewestUnitRisk",
      "changeObjsList",
      "changeActiveCountyId",
      "changeCardOption",
      "changeCardTypes",
      "changCardData",
      "changeAllCartShow",
      "changeCartShowHidden",
    ]),
    captureTxMsg(msg) {
      if (msg && msg.length > 11) {
        const m = msg.substring(0, 11) + "...";
        return m;
      }
      return msg;
    },
    async connectWebsocket() {
      let websocket;
      const fristShow = true;
      if (typeof WebSocket === "undefined") {
        // console.log('您的浏览器不支持WebSocket')
      } else {
        const { company } = this.$route.params;
        const { unit } = JSON.parse(localStorage.getItem(company));
        if (unit.unitids) {
          const result = await apiData.multiUnitObjs(unit.unitids);
          this.unitObjs = result.data;
        } else {
          const result = await apiData.unitObjs(unit.id);
          this.unitObjs = result.data;
        }
        // const url = `wss://www.gzqxfw.com.cn/gzfwitf/websktfw/${unit.id}`
        const wsHost = process.env.VUE_APP_WS;
        const url = `${wsHost}/fw-client/websktfw/${unit.id}`;
        // 打开一个websocket
        websocket = new WebSocket(url);
        // 建立连接
        websocket.onopen = () => {
          this.socketTimmer && clearInterval(this.socketTimmer);
        };

        // 客户端接收服务端返回的数据
        websocket.onmessage = (evt) => {
          const result = JSON.parse(evt.data);
          if (result.code === 200 && result.type === "unitRisk") {
            // const data = [];
            // if (Object.keys(result.data).length > 0) {
            //   const nameKeys = Object.keys(result.data);
            //   const nameValues = Object.values(result.data);

            //   nameKeys.forEach((nameItem, index) => {
            //     const levelKeys = Object.keys(nameValues[index]);
            //     let obj = {};
            //     obj.name = nameItem;
            //     obj.label = levelKeys[0];
            //     obj = { ...obj, ...nameValues[index][levelKeys[0]] };
            //     data.push(obj);
            //   });
            // }
            // if (data.length > 0) {
            //   this.riskFrist = true;
            // }
            console.log("气候风险", result.data);

            this.changeNewestUnitRisk(result.data);
          } else if (result.code === 200 && result.type === "newestZhuanBao") {
            this.zbNum = 0;
            result.data.reverse();
            this.zhuanbaoShow = false;
            if (result.data.length > 0) {
              const time = new Date(result.data[0].crttimeFmt).getTime();
              const nowTme = Date.now();
              if (nowTme - time < 3600000 * 12) {
                this.zbNum = this.zbNum + 1;
              }
              // this.changeNewestZhuanBao(result.data)
            } else {
              // this.changeNewestZhuanBao([])
            }
          } else if (result.code === 200 && result.type === "newestTxMsg") {
            if (result.data.length > 0) {
              const time = new Date(result.data[0].crttimeFmt).getTime();
              const nowTme = Date.now();
              console.log("time111", time);
              console.log("nowTme", nowTme);
              // 一小时 = 3600000毫秒
              // if (nowTme - time < 3600000 * 6) {
              this.newRFrist = true;
              this.tqtxShow = true;
              // }
              this.changeNewestTxMsg(result.data);
            } else {
              this.tqtxShow = false;
              this.changeNewestTxMsg([]);
            }
            console.log("this.tqtxShow", this.tqtxShow);
          } else if (
            result.code === 200 &&
            result.type === "newestAlarms" &&
            !this.unitObjs[0].town
          ) {
            // 采用区县数据
            this.newestAlarms = result.data;
          } else if (
            result.code === 200 &&
            result.type === "newestTownAlarms" &&
            this.unitObjs[0].town
          ) {
            // 采用镇街数据
            this.newestAlarms = result.data;
          } else if (result.code === 200 && result.type === "riskTypeCount") {
            const riskTypeCountList = result.data;
            console.log("riskTypeCountList", riskTypeCountList);
            this.changCardData({
              type: "riskTypeCount",
              data: riskTypeCountList,
            });
          } else if (result.code === 200 && result.type === "bxIndexRecord") {
            const bxIndexRecordList = result.data;
            this.changCardData({
              type: "bxIndexRecord",
              data: bxIndexRecordList,
            });
          }
        };
        // 发生错误时
        websocket.onerror = (evt) => {
          console.log("websocket错误：", evt);
          this.socketTimmer && clearInterval(this.socketTimmer);
          this.socketTimmer = setInterval(() => {
            this.connectWebsocket();
          }, 10000);
        };
        // 关闭连接
        websocket.onclose = (evt) => {
          console.log("websocket关闭：", evt);
          this.socketTimmer && clearInterval(this.socketTimmer);
          this.socketTimmer = setInterval(() => {
            this.connectWebsocket();
          }, 10000);
        };
      }
    },

    // 切换地图或者经纬度
    selectMap(type, index) {
      if (this.maps.includes(type)) {
        this.mapType = type;
        this.neibuType = "";
        this.map2d.changeMap(index);
      } else {
        if (this.fuzhuTypes.includes(type)) {
          const index = this.fuzhuTypes.findIndex((item) => item === type);
          this.fuzhuTypes.splice(index, 1);
        } else {
          this.fuzhuTypes.push(type);
        }

        if (this.fuzhuTypes.includes("经纬线")) {
          this.map2d.setGraticule(true);
        } else {
          this.map2d.setGraticule(false);
        }

        if (this.fuzhuTypes.includes("测距")) {
          if (!this.measureInstance) {
            this.measureInstance = new MeasureTools(this.map2d);
          }
          this.measureInstance.start(this.map2d, "LineString");
        } else {
          this.measureInstance.stop(this.map2d);
        }
      }
    },
    /**
     * 初始化
     */
    init() {
      const { company } = this.$route.params;
      const { unit } = JSON.parse(localStorage.getItem(company));
      this.companyName = unit.sysname;
      this.subname = unit.subname;
      this.labelid = unit.labelid;
      this.sysLogo = unit.logo ? "data:image/png;base64," + unit.logo : null;
      this.isjc = unit.isjc;
      Vue.prototype.$rootFontSize = (document.body.clientWidth / 1920) * 16;
      document.getElementsByTagName("html")[0].style.fontSize =
        this.$rootFontSize + "px";
      // 初始化地图
      this.map2d = new Map2d(this.options);
      // 设置地图的双击事件
      this.map2d.map.getInteractions().forEach((interaction) => {
        if (interaction instanceof DoubleClickZoom) {
          this.doubleClickZoomInteraction = interaction;
        }
      });
      this.addOverlayer();
      this.mapLister();
      this.interTime = setInterval(() => {
        this.day = this.$moment(new Date()).format("YYYY年MM月DD日");
        this.time = this.$moment(new Date()).format("HH:mm:ss");
      }, 1000);
      this.showPlaneGeoJson();
      localStorage.setItem("dialogZIndex", "9");
    },
    /**
     * 显示面
     */
    async showPlaneGeoJson() {
      const { company } = this.$route.params;
      console.log("company", company);
      const { unit } = JSON.parse(localStorage.getItem(company));
      console.log("unit", unit);
      const display = unit.display;
      const plotdisplay = unit.plotdisplay;
      this.showBorderImage(unit);
      // 如果不是面 就不需
      if (display !== "plane") {
        return;
      }
      const geojson = await apiData.getGeoJson(unit.plotjson);
      // 佛山地铁路线图特殊处理
      if (company === "fsmetro") {
        console.log("触发了");
        this.showFSMetroRoutes(geojson, plotdisplay);
        return;
      }
      // 正面部分
      if (plotdisplay === "transparent") {
        this.displayLayer = new VectorLayer({
          source: new VectorSource({
            features: new GeoJSON().readFeatures(geojson),
          }),
          style: new Style({
            stroke: new Stroke({
              color: "#33ced3",
              width: 3,
            }),
            fill: new Fill({
              color: "rgba(62, 109, 132, 0.1)",
            }),
          }),
        });
      } else {
        this.displayLayer = new VectorLayer({
          source: new VectorSource({
            features: new GeoJSON().readFeatures(geojson),
          }),
          style: new Style({
            stroke: new Stroke({
              color: "#33ced3",
              width: 3,
            }),
            fill: new Fill({
              color: "rgba(62, 109, 132, 1)",
            }),
          }),
        });
      }

      this.displayLayer.setZIndex(9);
      this.map2d.map.addLayer(this.displayLayer);
      // 阴影部分
      if (plotdisplay === "shadow") {
        const offsetGeoJson = this.offsetGeoJSON(geojson, 0, -0.0014);
        this.displayLayer2 = new VectorLayer({
          source: new VectorSource({
            features: new GeoJSON().readFeatures(offsetGeoJson),
          }),
          style: new Style({
            stroke: new Stroke({
              color: "#596b77",
              width: 2.5,
            }),
            fill: new Fill({
              color: "rgba(2, 31, 46, 0.8)",
            }),
          }),
        });
        this.displayLayer2.setZIndex(8);
        this.map2d.map.addLayer(this.displayLayer2);
      }
    },
    /**
     * 处理 fsmetro 的路线显示
     */
    showFSMetroRoutes(geojson, plotdisplay) {
      console.log("=== showFSMetroRoutes 调试 ===");

      // 1. 清空旧图层
      this.clearRouteLayers();

      // 2. 解析 GeoJSON
      const features = new GeoJSON().readFeatures(geojson);

      // 3. 过滤出所有 MultiLineString
      const routeFeatures = features.filter((feature) => {
        const geometry = feature.getGeometry();
        return geometry && geometry.getType() === "MultiLineString";
      });

      if (routeFeatures.length === 0) {
        console.warn("未找到 MultiLineString 类型的路线");
        return;
      }

      console.log("找到路线数量:", routeFeatures.length);

      const fillColor =
        plotdisplay === "transparent"
          ? "rgba(62, 109, 132, 0.1)"
          : "rgba(62, 109, 132, 1)";

      const routeNames = [];
      const layers = [];

      // 4. 创建路线图层
      routeFeatures.forEach((feature, index) => {
        const name = feature.get("name") || "未命名路线";
        const routeColor = this.getRouteColor(name);
        routeNames.push(name);

        const layer = new VectorLayer({
          source: new VectorSource({
            features: [feature],
          }),
          style: new Style({
            stroke: new Stroke({
              color: routeColor,
              width: 4,
            }),
            fill: new Fill({
              color: fillColor,
            }),
          }),
        });

        layer.set("routeName", name);

        layer.setZIndex(9);
        this.map2d.map.addLayer(layer);
        layers.push(layer);
      });

      // 5. 保存到 data 中
      this.routeLayers = layers;
      this.routeOptions = routeNames.map((name, index) => ({
        value: name,
        label: this.getRouteLabel(name, index),
        color: this.getRouteBtnColor(name),
        bg: this.getRouteBtnBg(name),
      }));

      // 6. 默认全选
      this.selectedRoutes = this.routeOptions.map((item) => item.value);

      this.map2d.map.render();
      console.log("所有路线已添加，共", routeFeatures.length, "条");
      console.log("路线选项:", this.routeOptions);

      // ✅ 7. 应用点位可见性
      this.$nextTick(() => {
        this.updateStationVisibility();
      });
    },
    /**
     * 自定义路线 Label
     */
    getRouteLabel(name, index) {
      // ✅ 你可以在这里自定义显示名称
      const labelMap = {
        "南海有轨电车1号线(林岳东--礌岗)": "南海有轨电车1号线",
        "佛山地铁2号线(广州南站--南庄)": "佛山地铁2号线",
        "地铁3号线(佛山大学--顺德学院站)": "佛山地铁3号线",
      };
      return labelMap[name] || `${index + 1}. ${name}`;
    },
    toggleRoute(value) {
      const index = this.selectedRoutes.indexOf(value);
      if (index > -1) {
        this.selectedRoutes.splice(index, 1);
      } else {
        this.selectedRoutes.push(value);
      }
    },
    getRouteColor(name) {
      const colorMap = {
        "佛山地铁2号线(广州南站--南庄)": "#ed2736",
        "地铁3号线(佛山大学--顺德学院站)": "#0033a0",
        "南海有轨电车1号线(林岳东--礌岗)": "#63b5e5",
      };
      return colorMap[name] || "#33ced3";
    },
    getRouteBtnColor(name) {
      const colorMap = {
        "佛山地铁2号线(广州南站--南庄)": "#EE2737",
        "地铁3号线(佛山大学--顺德学院站)": "#0071FF",
        "南海有轨电车1号线(林岳东--礌岗)": "#69B9FF",
      };
      return colorMap[name] || "#33ced3";
    },
    getRouteBtnBg(name) {
      const bgMap = {
        "佛山地铁2号线(广州南站--南庄)": require("@/assets/images/line2.png"),
        "地铁3号线(佛山大学--顺德学院站)": require("@/assets/images/line3.png"),
        "南海有轨电车1号线(林岳东--礌岗)": require("@/assets/images/line1.png"),
      };
      return bgMap[name] || "";
    },
    /**
     * 更新路线可见性（简化版，无阴影）
     */
    updateRouteVisibility() {
      console.log("当前 selectedRoutes:", this.selectedRoutes);

      // 控制路线图层
      this.routeLayers.forEach((layer) => {
        const routeName = layer.get("routeName");
        const shouldShow = this.selectedRoutes.includes(routeName);
        layer.setVisible(shouldShow);
      });

      // ✅ 佛山地铁：重新渲染所有要素（点位、温度、风速等）
      if (this.companyName === "佛山地铁") {
        // 重新绘制点位图标
        this.drawICon();

        // 重新绘制要素（温度、风速等）
        this.drapFactsText(["temp", "windd_dir", "r01h", "rh", "light"]);
        this.updateMetroThinning(true);
      }
    },

    /**
     * 清除所有路线图层
     */
    clearRouteLayers() {
      // 清除路线图层
      this.routeLayers.forEach((layer) => {
        this.map2d.map.removeLayer(layer);
      });
      this.routeLayers = [];
      // ✅ 重置点位可见性（恢复显示）
      this.stationFeatures.forEach((feature) => {
        const currentStyle = feature.getStyle();
        if (currentStyle) {
          const newStyle = currentStyle.clone();
          const image = newStyle.getImage();
          if (image) {
            image.setOpacity(1);
          }
          feature.setStyle(newStyle);
        }
      });
      if (this.iconSource) {
        this.iconSource.changed();
      }

      this.routeOptions = [];
      this.selectedRoutes = [];
    },
    /**
     * 颜色转换工具
     */
    hexToRgba(hex, alpha) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      if (result) {
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }
      return `rgba(62, 109, 132, ${alpha})`;
    },
    offsetCoordinates(coords, dx, dy) {
      if (Array.isArray(coords[0])) {
        return coords.map((c) => this.offsetCoordinates(c, dx, dy));
      }
      return [coords[0] + dx, coords[1] + dy];
    },
    showBorderImage(unit) {
      if (!unit || !unit.bacpath || !unit.bacpoint) {
        console.log("未设置区域图片");
        return;
      }
      const bacpath = unit.bacpath;
      const bacpoint = JSON.parse(unit.bacpoint);
      const extent = [bacpoint[0], bacpoint[2], bacpoint[1], bacpoint[3]];
      if (this.jhwImagelayer === "") {
        this.jhwImagelayer = new ImageLayer({
          zIndex: 10,
          opacity: 1,
        });
        this.map2d.map.addLayer(this.jhwImagelayer);
      }
      const imageUrl = apiData.getUnitBorderImg(bacpath);
      const source = new ImageStatic({
        // url: require('@/assets/images/jhw_border.png'),
        // imageExtent: [113.115589397, 22.895026321, 113.160753499, 22.918380249],
        url: imageUrl,
        imageExtent: extent,
      });
      this.jhwImagelayer.setSource(source);
    },
    offsetGeoJSON(geojson, dx, dy) {
      // 深度复制GeoJSON对象以避免修改原始对象
      const offsetGeoJSON = JSON.parse(JSON.stringify(geojson));

      // 遍历GeoJSON中的所有点
      const offsetCoordinate = function (coord) {
        return [coord[0] + dx, coord[1] + dy];
      };

      const offsetGeometry = function (geometry) {
        if (geometry.type === "Point") {
          geometry.coordinates = offsetCoordinate(geometry.coordinates);
        } else if (
          geometry.type === "MultiPoint" ||
          geometry.type === "LineString"
        ) {
          geometry.coordinates = geometry.coordinates.map(offsetCoordinate);
        } else if (
          geometry.type === "MultiLineString" ||
          geometry.type === "Polygon"
        ) {
          geometry.coordinates = geometry.coordinates.map((subCoordinates) =>
            subCoordinates.map(offsetCoordinate)
          );
        } else if (geometry.type === "MultiPolygon") {
          geometry.coordinates = geometry.coordinates.map((subCoordinates) =>
            subCoordinates.map((subSubCoordinates) =>
              subSubCoordinates.map(offsetCoordinate)
            )
          );
        }
        return geometry;
      };

      if (offsetGeoJSON.geometry) {
        offsetGeometry(offsetGeoJSON.geometry);
      } else {
        offsetGeoJSON.features.forEach((feature) => {
          offsetGeometry(feature.geometry);
        });
      }

      return offsetGeoJSON;
    },
    /** init
     * 24小时预报切换不同时间段显示
     */
    changeHourForecast(num) {
      /**
       * 面板最大显示5个时间的总共宽度
       */
      const hourForecastWidth = 27.9;
      const max = -4;
      this.currentHourForecast += num;
      if (this.currentHourForecast > 0) {
        this.currentHourForecast = 0;
        return;
      }
      if (this.currentHourForecast < max) {
        this.currentHourForecast = max;
        return;
      }
      this.$refs.hourForecastList.style.left = `${hourForecastWidth * this.currentHourForecast
        }rem`;
    },

    /**
     * 显示隐藏产品
     */
    async toggleProductView(ename, component) {
      // 首先判断是否外链
      if (component && component.wblink) {
        window.open(component.wblink, "_blank");
        return;
      }
      const index = this.components.findIndex((item) => item.ename === ename);
      if (this.selectedNavs.includes(ename)) {
        this.selectedNavs.splice(this.selectedNavs.indexOf(ename), 1);
        this.components[index].params.flag = false;
      } else {
        console.log("this.codesInfo", this.codesInfo);
        // 隐藏同组产品getUnitInfo
        let group;
        if (this.codesInfo[ename]) {
          group = this.codesInfo[ename].group;
        }
        this.selectedNavs.forEach((item) => {
          let groupSelected;
          if (this.codesInfo[item]) {
            groupSelected = this.codesInfo[item].group;
          }
          if (group === groupSelected) {
            this.toggleProductView(item);
          }
        });

        const result = await this.loadProduct(ename);
        if (result) {
          this.selectedNavs.push(ename);
        }
      }

      this.hideDialog(ename);
    },

    // 隐藏弹框,
    hideDialog(ename) {
      let ignoreComponents = ["A01", "A02", "A03", "A04", "A11", "A13"];
      if (ename === "C09") {
        ignoreComponents = ["A02", "A03", "A11"];
        const deleteCode = ["A01", "A04", "A12"];
        deleteCode.forEach((code) => {
          const index = this.selectRightTopData.findIndex(
            (item) => item === code
          );
          if (index > -1) this.selectRightTopData.splice(index, 1);
        });
      }
      this.components.map((item, index) => {
        if (!ignoreComponents.includes(item.ename)) {
          if (ename !== item.ename) {
            item.params.flag = false;
          }
        }
      });
      this.selectedNavs.forEach((item, index) => {
        if (!ignoreComponents.includes(item)) {
          if (ename !== item) {
            this.selectedNavs.splice(index, 1);
          }
        }
      });
      // this.selectRightTopData.forEach((item, index) => {
      //   if (!ignoreComponents.includes(item)) {
      //     if (ename !== item) {
      //       this.selectRightTopData.splice(index, 1)
      //     }
      //   }
      // })
      // 台风和卡片只能显示其中一个
      if (
        this.selectedNavs.includes("C09") ||
        this.selectRightTopData.includes("A02")
      ) {
        this.changeAllCartShow(false);
        this.cardShow = true;
      } else if (this.cardShow) {
        this.changeAllCartShow(true);
        this.cardShow = false;
      }
    },

    /**
     * 加载产品
     * @param {String} ename
     */
    async loadProduct(ename) {
      console.log("loadProduct", ename);
      const index = this.components.findIndex((item) => item.ename === ename);
      let result = true;
      if (index < 0) {
        let componentName = ename;
        if (this.codesInfo[ename]) {
          componentName = this.codesInfo[ename].componentName;
        }
        await import("../components/" + componentName + ".vue")
          .then((modules) => {
            Vue.component(ename, (resolve) => resolve(modules));
            let productInfo = this.codesInfo[ename];
            const i = this.navs.findIndex((item) => item.code === ename);
            const j = this.rightTopData.findIndex(
              (item) => item.code === ename
            );
            if (i >= 0) {
              productInfo = { ...productInfo, ...this.navs[i] };
            }
            if (j >= 0) {
              productInfo = { ...productInfo, ...this.rightTopData[j] };
            }
            console.log("productInfo", productInfo);
            this.components.push({
              ename,
              params: {
                flag: true,
                map2d: this.map2d,
                productInfo,
              },
            });
          })
          .catch(() => {
            if (ename === "M1") {
              this.$message.error("当前无风球信号！");
            } else {
              this.$message.error("该模块正在建设中！");
            }
            result = false;
          });
      } else {
        this.components[index].params.flag = true;
      }
      return result;
    },

    /**
     * 获取导航
     */
    async listColumn() {
      const company = this.$route.params.company;
      const { unit } = JSON.parse(localStorage.getItem(company));
      // const params = { unitid: unit.id };
      const result = await apiData.listColumn(unit.id);
      const {
        cardcol,
        cardcols,
        invalidServercol,
        invalidSwitchcol,
        servercols,
        switchcols,
      } = result.data;
      console.log(cardcol, cardcols, servercols, switchcols);
      this.navs = servercols.filter(
        (item) => !invalidServercol.includes(item.id)
      );
      console.log("this.navs", this.navs);
      this.rightTopData = switchcols.filter(
        (item) => !invalidSwitchcol.includes(item.id)
      );
      const cardData = cardcols;
      this.changeCardOption(cardData);
      const switchids = unit.switchids;
      console.log("switchcols", switchcols);
      const ldhb = switchcols.find((v) => v.code === "A01");
      // if (ldhb && switchids) {
      //   const ids = switchids.split(',')
      //   console.log('ids', ids, 'ldhb', ldhb)
      //   if (ids.includes(String(ldhb.id))) {
      //     this.selectedNavs.push('A01')
      //     this.selectRightTopData.push('A01')
      //   }
      // }
      // console.log('ldhb', ldhb)
      // console.log('switchids', switchids)
      // this.rightTopData.forEach((item) => {
      //   if (item.code === 'A01') {
      //     this.selectedNavs.push('A01')
      //     this.selectRightTopData.push('A01')
      //   }
      // })
    },

    async getDate() {
      const company = this.$route.params.company;
      console.log("company", company);
      const { unit } = JSON.parse(localStorage.getItem(company));
      console.log("unit", unit);
      this.changeCardTypes(unit);
      // const params = { unitid: unit.id };
      // 获取所有的单位对象
      if (unit.unitids) {
        const result = await apiData.multiUnitObjs(unit.unitids);
        this.unitObjs = result.data;
      } else {
        const result = await apiData.unitObjs(unit.id);
        this.unitObjs = result.data;
      }

      const fristUnitObj = this.unitObjs[0];
      if (!unit.centlat) {
        if (fristUnitObj && fristUnitObj.lat && fristUnitObj.lon) {
          unit.centlat = fristUnitObj.lat;
          unit.centlon = fristUnitObj.lon;
        }
      }
      unit.maplevel = unit.maplevel || 9;
      const { centlat, centlon, maplevel } = unit;
      this.maplevel = maplevel;

      this.unitCenter = {
        centlat,
        centlon,
        maplevel,
      };

      console.log("mapInfo", centlat, centlon, maplevel);

      this.alarmAear = this.unitObjs[0].area;
      // if (unit.town) {
      //   // 默认获取第一个单位对象的天气实况
      //   this.alarmArea = fristUnitObj.town;
      // } else {
      //   // 默认获取第一个单位对象的天气实况
      //   this.alarmArea = fristUnitObj.county;
      // }
      if (this.unitObjs[0].town) {
        // 默认获取第一个单位对象的天气实况
        this.alarmArea = fristUnitObj.town;
      } else {
        // 默认获取第一个单位对象的天气实况
        this.alarmArea = fristUnitObj.county;
      }

      // console.log("fristUnitObj", fristUnitObj);
      // 默认定位第一个点
      // const {
      //   lat,
      //   lon
      // } = fristUnitObj
      // 暂时对云浮单位额外处理
      if (unit.sysname === "世界黄皮公园") {
        this.map2d.map.getView().setCenter([111.5532992, 23.1243158]);
      } else {
        this.map2d.map.getView().setCenter([centlon, centlat]);
      }
      this.map2d.map.getView().setZoom(maplevel);
      localStorage.setItem("objsList", JSON.stringify(this.unitObjs));
      localStorage.setItem("activeCountyId", JSON.stringify(fristUnitObj.id));
      this.changeObjsList(this.unitObjs);
      this.changeActiveCountyId(fristUnitObj.id);
      await this.getGiftLive();
      // 获取卡片的数据
      this.getRightCardData();

      // 根据单位的scope,默认显示的是广州或者广东地图和预警
      const scope = unit.scope;
      if (scope === "GD") {
        this.tabItemClick("right-bottom", 0);
      }
    },

    // 获取卡片的数据
    async getRightCardData() {
      const index = this.unitObjs.findIndex(
        (item) => item.id === this.activeCountyId
      );
      const lon = (Math.round(this.unitObjs[index].lat / 0.05) * 0.05)
        .toFixed(2)
        .replace(/\./g, "");
      const lat = (Math.round(this.unitObjs[index].lon / 0.05) * 0.05)
        .toFixed(2)
        .replace(/\./g, "");
      const company = this.$route.params.company;
      const { unit } = JSON.parse(localStorage.getItem(company));
      try {
        const slideliveResult = await apiData.sildeLive(
          this.unitObjs[index].id,
          24,
          "obj"
        );
        this.changCardData({
          type: "slideLive",
          data: slideliveResult.data,
        });
      } catch (error) { }
      try {
        const riskShortResult = await apiData.riskShort(this.activeCountyId);
        this.changCardData({
          type: "riskShort",
          data: riskShortResult,
        });
      } catch (error) { }
      try {
        const indexNumberResult = await apiData.indexNumber(
          this.activeCountyId
        );
        this.changCardData({
          type: "indexNumber",
          data: indexNumberResult.data,
        });
      } catch (error) { }
      try {
        const suitabilityNumberResult = await apiData.suitabilityNumber(
          this.activeCountyId
        );
        this.changCardData({
          type: "suitabilityNumber",
          data: suitabilityNumberResult.data,
        });
      } catch (error) { }
      try {
        const giftDataResult = await apiData.giftData(lat, lon);
        this.changCardData({
          type: "giftData",
          data: giftDataResult,
        });
      } catch (error) { }
      try {
        // const wheatherLiveResult = await apiData.queryWheatherLiveData();
        // this.obtPTime = wheatherLiveResult[this.unitObjs[index].id].ddatetime;
        // const tqskDateResult = wheatherLiveResult[this.unitObjs[index].id];
        // this.changCardData({
        //   type: "tqskDate",
        //   data: tqskDateResult,
        // });
        const wheatherLiveResult = await apiData.queryWheatherLiveDataByUnitid(
          unit.id
        );
        this.obtPTime = wheatherLiveResult.data.find(
          (item) => item.objid === this.activeCountyId
        ).ddatetime;
        const tqskDateResult = wheatherLiveResult.data.find(
          (item) => item.objid === this.activeCountyId
        );
        this.changCardData({
          type: "tqskDate",
          data: tqskDateResult,
        });
      } catch (error) { }

      try {
        const riskForeResult = await apiData.riskFore(this.activeCountyId);
        console.log("riskForeResult", riskForeResult);
        this.changCardData({
          type: "riskFore",
          data: riskForeResult.data,
        });
      } catch (error) { }
      try {
        const stpResult = await apiData.getStpData(this.activeCountyId);
        this.changCardData({
          type: "stp",
          data: stpResult.data,
        });
        console.log("stpResult", stpResult);
      } catch (error) { }
      try {
        const ultravioletRaysData = await apiData.queryUltravioletRaysData();
        this.changCardData({
          type: "ultravioletRays",
          data: ultravioletRaysData.data,
        });
      } catch (error) { }
      try {
        const sevenDayData = await apiData.querySevenDayData();
        console.log("sevenDayData", sevenDayData);
        this.changCardData({
          type: "sevenDayData",
          data: sevenDayData.data,
        });
      } catch (error) { }
      try {
        const unitPointData = await apiData.getUnitPointData(unit.id);
        console.log("unitPointData", unitPointData);
        this.changCardData({
          type: "unitPointData",
          data: unitPointData.data,
        });
      } catch (error) { }
      try {
        const zjStationData = await apiData.getZjStationData(unit.id);
        console.log("zjStationData", zjStationData);
        this.changCardData({
          type: "unitZjStationData",
          data: zjStationData.data,
        });
      } catch (error) { }
      try {
        const airQualityData = await apiData.queryAirQuality();
        this.changCardData({
          type: "airQualityData",
          data: airQualityData.data,
        });
      } catch (error) { }
      try {
        const refinedRainData = await apiData.queryRefindRain(lon);
        this.changCardData({
          type: "refinedRainData",
          data: refinedRainData.data,
        });
      } catch (error) { }
      try {
        const countyOccupantData = await apiData.querycountyOccupant();
        this.changCardData({
          type: "countyOccupant",
          data: countyOccupantData,
        });
      } catch (error) { }
      try {
        if (this.hasCard(58)) {
          const shuiWenStationSlideResult =
            await apiData.shuiwenStationSlideData(this.unitObjs[index].obtid);
          this.changCardData({
            type: "shuiWenStationSlide",
            data: shuiWenStationSlideResult.data,
          });
        }
      } catch (error) { }
    },
    hasCard(cardId) {
      const cartData = this.cartData;
      for (let i = 0; i < cartData.length; i++) {
        if (cartData[i].types.findIndex((v) => v === cardId) !== -1) {
          return true;
        }
      }
      return false;
    },
    // 绘制地图图标
    async drawICon() {
      if (!this.iconlayer) {
        this.iconSource = new VectorSource();
        this.iconlayer = new VectorLayer({
          zIndex: 999,
          source: this.iconSource,
        });
        this.map2d.map.addLayer(this.iconlayer);
      }
      this.iconSource && this.iconSource.clear();
      const features = [];

      // ✅ 清空之前保存的点位引用
      this.stationFeatures = [];

      this.iconRedStyle = new Style({
        image: new Icon({
          src: require("@/assets/images/map-red.png"),
          scale: 0.4,
        }),
      });
      this.iconOrangeStyle = new Style({
        image: new Icon({
          src: require("@/assets/images/map-orange.png"),
          scale: 0.4,
        }),
      });
      this.iconYellowStyle = new Style({
        image: new Icon({
          src: require("@/assets/images/map-yellow.png"),
          scale: 0.4,
        }),
      });
      this.iconBlueStyle = new Style({
        image: new Icon({
          src: require("@/assets/images/map-blue.png"),
          scale: 0.4,
        }),
      });
      this.activeIconStyle = new Style({
        image: new Icon({
          src: require("@/assets/images/定位选中.png"),
          scale: 0.4,
        }),
      });

      const { company } = this.$route.params;
      const { unit } = JSON.parse(localStorage.getItem(company));
      const isFSMetro = company === "fsmetro";

      console.log("this.tableData", this.tableData);
      this.tableData.forEach((item, index) => {
        if (isFSMetro) {
          const routeName = this.stationRouteMap[item.name];
          if (routeName && !this.selectedRoutes.includes(routeName)) {
            return; // 跳过这个点位
          }
        }
        // 云浮额外处理
        if (unit.sysname === "世界黄皮公园") {
          item.lon = 111.5532992;
          item.lat = 23.1243158;
        }
        const positon = [item.lon, item.lat];
        if (this.activeCountyId === item.id && !this.fristDrap) {
          this.fristDrap = true;
        }
        // 创建icon图标
        const iconFeature = new Feature({
          geometry: new Point(positon),
          name: "feature",
          point: item,
          index: index,
        });
        iconFeature.set("pointType", "obj");
        iconFeature.set("pointName", item.name);
        iconFeature.set("pointId", item.id);

        // ✅ 如果是佛山地铁，设置归属路线
        if (isFSMetro) {
          const routeName = this.stationRouteMap[item.name];
          if (routeName) {
            iconFeature.set("routeName", routeName);
            iconFeature.set("isStation", true);
          }
        }

        if (this.activeCountyId === item.id) {
          iconFeature.setStyle(this.activeIconStyle);
          this.activePoint = point;
          this.iconFeature = iconFeature;
        } else {
          iconFeature.setStyle(this.mapIconColor(item.r01h));
        }

        features.push(iconFeature);

        // ✅ 保存点位 feature 引用
        if (isFSMetro) {
          this.stationFeatures.push(iconFeature);
        }

        this.drawOverlay(item, index);
      });
      this.iconSource.addFeatures(features);
      this.iconSource.changed();

      // ✅ 如果是佛山地铁，初始化时应用路线过滤和抽稀
      if (isFSMetro && this.selectedRoutes.length > 0) {
        this.updateMetroThinning(true);
      }
    },
    getMetroThinningConfig(zoom) {
      if (zoom >= 14) {
        return { minPx: 0, hideInterval: false, hideFacility: false };
      }
      if (zoom >= 13) {
        return { minPx: 40, hideInterval: false, hideFacility: false };
      }
      if (zoom >= 12) {
        return { minPx: 56, hideInterval: true, hideFacility: false };
      }
      if (zoom >= 11) {
        return { minPx: 72, hideInterval: true, hideFacility: true };
      }
      return { minPx: 96, hideInterval: true, hideFacility: true };
    },
    getMetroPointType(name) {
      if (this.metroKeyStations.includes(name)) {
        return "key";
      }
      if (/车辆段|停车场|主所|控制中心/.test(name)) {
        return "facility";
      }
      if (
        /[—－]/.test(name) ||
        name.includes("区间") ||
        name.includes("U型槽")
      ) {
        return "interval";
      }
      return "station";
    },
    getMetroPixelDistance(pointA, pointB) {
      const map = this.map2d && this.map2d.map;
      if (!map) {
        return Infinity;
      }
      const px1 = map.getPixelFromCoordinate([pointA.lon, pointA.lat]);
      const px2 = map.getPixelFromCoordinate([pointB.lon, pointB.lat]);
      if (!px1 || !px2) {
        return Infinity;
      }
      const dx = px1[0] - px2[0];
      const dy = px1[1] - px2[1];
      return Math.sqrt(dx * dx + dy * dy);
    },
    isMetroPointVisible(name) {
      if (!name) {
        return true;
      }
      const routeName = this.stationRouteMap[name];
      if (routeName && !this.selectedRoutes.includes(routeName)) {
        return false;
      }
      return !this.hiddenStationNames.includes(name);
    },
    computeMetroThinnedNames(zoom) {
      const config = this.getMetroThinningConfig(zoom);
      const candidates = (this.tableData || []).filter((item) => {
        const routeName = this.stationRouteMap[item.name];
        return routeName && this.selectedRoutes.includes(routeName);
      });
      if (!candidates.length) {
        return [];
      }
      if (config.minPx <= 0 && !config.hideInterval && !config.hideFacility) {
        return [];
      }

      const hidden = [];
      const pool = [];
      candidates.forEach((item) => {
        const type = this.getMetroPointType(item.name);
        if (type === "interval" && config.hideInterval) {
          hidden.push(item.name);
          return;
        }
        if (type === "facility" && config.hideFacility) {
          hidden.push(item.name);
          return;
        }
        pool.push({
          name: item.name,
          lon: item.lon,
          lat: item.lat,
          type,
        });
      });

      const kept = pool.filter((item) => item.type === "key");
      const rest = pool
        .filter((item) => item.type !== "key")
        .sort((a, b) => {
          const order = { station: 0, facility: 1, interval: 2 };
          return order[a.type] - order[b.type];
        });

      rest.forEach((item) => {
        const tooClose =
          config.minPx > 0 &&
          kept.some(
            (keptItem) =>
              this.getMetroPixelDistance(item, keptItem) < config.minPx
          );
        if (tooClose) {
          hidden.push(item.name);
        } else {
          kept.push(item);
        }
      });
      return hidden;
    },
    applyMetroFeatureVisibility(source) {
      if (!source) {
        return;
      }
      source.getFeatures().forEach((feature) => {
        const name = feature.get("pointName");
        if (!name || !this.stationRouteMap[name]) {
          return;
        }
        const visible = this.isMetroPointVisible(name);
        const style = feature.getStyle();
        if (!style) {
          return;
        }
        const image = style.getImage();
        if (image) {
          image.setOpacity(visible ? 1 : 0);
        }
        const text = style.getText();
        if (text) {
          text.setScale(visible ? 1 : 0);
        }
        feature.setStyle(style);
      });
      source.changed();
    },
    // 站点要素隐藏处理
    applyMetroFactVisibility() {
      this.applyMetroFeatureVisibility(this.textSource);
      this.applyMetroFeatureVisibility(this.dataPointSource);
      this.applyMetroFeatureVisibility(this.zjPointSource);
    },
    // 站名图层处理
    updateMetroNameOverlays() {
      this.overlayerLayers.forEach((overlayer) => {
        const data =
          overlayer.get("data") ||
          (overlayer.options && overlayer.options.data);
        if (!data || !data.name || !this.stationRouteMap[data.name]) {
          return;
        }
        if (this.isMetroPointVisible(data.name)) {
          overlayer.setPosition([data.lon, data.lat]);
        } else {
          overlayer.setPosition(undefined);
        }
      });
    },
    applyMetroThinningDisplay() {
      this.updateStationVisibility();
      this.updateMetroNameOverlays();
      this.applyMetroFactVisibility();
    },
    updateMetroThinning(force = false) {
      if (this.companyName !== "佛山地铁") {
        return;
      }
      if (!this.map2d || !this.map2d.map) {
        return;
      }
      const zoom = this.map2d.map.getView().getZoom();
      const zoomKey = Math.round(zoom * 2) / 2;
      if (!force && zoomKey === this.lastMetroThinningZoom) {
        this.applyMetroThinningDisplay();
        return;
      }
      this.lastMetroThinningZoom = zoomKey;
      this.hiddenStationNames = this.computeMetroThinnedNames(zoom);
      this.applyMetroThinningDisplay();
    },
    // 站点图标隐藏处理
    updateStationVisibility() {
      const isFSMetro = this.companyName === "佛山地铁";
      if (!isFSMetro) return;

      this.stationFeatures.forEach((feature) => {
        const name = feature.get("pointName");
        const routeName = feature.get("routeName");
        if (routeName || name) {
          const shouldShow = this.isMetroPointVisible(name);
          const currentStyle = feature.getStyle();
          if (currentStyle) {
            const newStyle = currentStyle.clone();
            const image = newStyle.getImage();
            if (image) {
              image.setOpacity(shouldShow ? 1 : 0);
              // image.setScale(shouldShow ? 0.4 : 0.3);
            }
            feature.setStyle(newStyle);
          }
        }
      });

      // 强制刷新
      this.iconSource && this.iconSource.changed();
    },
    mapIconColor(rain) {
      if (rain === 9999) {
        rain = 0;
      }
      if (rain >= 50) {
        return this.iconRedStyle;
      } else if (rain >= 30) {
        return this.iconOrangeStyle;
      } else if (rain >= 20) {
        return this.iconYellowStyle;
      } else {
        return this.iconBlueStyle;
      }
    },

    // 一次性添加overlayer
    addOverlayer() {
      const overlayers = ["thunderOverlayer"];
      overlayers.forEach((overlayer) => {
        const element = this.$refs[overlayer + "Ref"].$el;
        this[overlayer] = new Overlay({
          position: undefined,
          positioning: "bottom-center",
          offset: [0, -60],
          element: element,
          overlayer: true,
        });
        this.map2d.map.addOverlay(this[overlayer]);
      });
    },

    // 添加自动站名称overlayer
    drawOverlay(point, index) {
      if (this.companyName === "佛山地铁") {
        const existing = this.overlayerLayers.find((ol) => {
          const data = ol.options.data;
          return data && data.id === point.id;
        });
        if (existing) {
          // 已存在，只更新位置
          existing.setPosition([point.lon, point.lat]);
          return;
        }
      }
      const elRef = document.createElement("div");
      elRef.setAttribute("class", "overlayerRef");
      elRef.innerText = point.name;
      const overlayer = new Overlay({
        position: undefined,
        positioning: "bottom-center",
        offset: [0, -30],
        element: elRef,
        data: point,
        index: index,
        overlayer: true,
      });
      if (this.companyName === "佛山地铁") {
        const routeName = this.stationRouteMap[point.name];
        if (routeName) {
          overlayer.set("routeName", routeName);
          overlayer.set("isStationOverlay", true);
        }
      }
      this.overlayerLayers.push(overlayer);
      this.map2d.map.addOverlay(overlayer);
    },

    addDataPointOverLayers(point, index) {
      const elRef = document.createElement("div");
      elRef.setAttribute("class", "overlayerRef");
      elRef.innerText = point.pname;
      const overlayer = new Overlay({
        position: undefined,
        positioning: "bottom-center",
        offset: [0, -30],
        element: elRef,
        data: point,
        index: index,
        overlayer: true,
      });
      this.dataPointOverlayerLayers.push(overlayer);
      this.map2d.map.addOverlay(overlayer);
    },

    addZjStationDataOverLayers(point, index) {
      const elRef = document.createElement("div");
      elRef.setAttribute("class", "overlayerRef");
      elRef.innerText = point.staname;
      const overlayer = new Overlay({
        position: undefined,
        positioning: "bottom-center",
        offset: [0, -30],
        element: elRef,
        data: point,
        index: index,
        overlayer: true,
      });
      this.zjStationDataResultOverlayerLayers.push(overlayer);
      this.map2d.map.addOverlay(overlayer);
    },

    removeDataPointOverLayers() {
      for (let i = 0; i < this.dataPointOverlayerLayers.length; i++) {
        this.map2d.map.removeOverlay(this.dataPointOverlayerLayers[i]);
      }
      this.dataPointOverlayerLayers = [];
    },

    removezjStationDataOverLayers() {
      for (let i = 0; i < this.zjStationDataResultOverlayerLayers.length; i++) {
        this.map2d.map.removeOverlay(
          this.zjStationDataResultOverlayerLayers[i]
        );
      }
      this.zjStationDataResultOverlayerLayers = [];
    },

    // 首页全部栏目的点击
    tabItemClick(position, index, component) {
      switch (position) {
        case "right-bottom":
          if (index === 2) {
            this.rightBottomData[index].select =
              !this.rightBottomData[index].select;
            this.warnLayer.setVisible(this.rightBottomData[index].select);
          } else {
            const index1 = index === 0 ? 1 : 0;
            this.rightBottomData[index].select = true;
            this.rightBottomData[index1].select = false;
            this.rightBottomData[3].select = false;
            const objData = this.unitObjs.find(
              (item) => item.id === this.activeCountyId
            );
            const { company } = this.$route.params;
            const { unit } = JSON.parse(localStorage.getItem(company));

            const position = [Number(objData.lon), Number(objData.lat)];
            if (index === 0) {
              this.map2d.map.getView().setZoom(7);
              // this.map2d.map.getView().setCenter([113.580637, 23.05178])
              this.map2d.map.getView().setCenter(this.center);
            } else if (index === 1) {
              this.map2d.map.getView().setZoom(9);
              // this.map2d.map.getView().setCenter([113.580637, 23.25178])
              if (objData.name === "世界黄皮公园") {
                this.map2d.map.getView().setCenter([111.5532992, 23.1243158]);
              } else {
                this.map2d.map.getView().setCenter(this.center);
              }
            } else {
              for (let i = 0; i < this.selectRightTopData.length; i++) {
                const ename = this.selectRightTopData[i];
                const index = this.components.findIndex(
                  (item) => item.ename === ename
                );
                console.log("index", index);
                if (this.selectedNavs.includes(ename)) {
                  console.log("this.selectedNavs", this.selectedNavs);
                  this.selectedNavs.splice(this.selectedNavs.indexOf(ename), 1);
                  this.components[index].params.flag = false;
                  console.log("this.selectedNavs", this.selectedNavs);
                }
              }
              this.selectRightTopData = [];
              this.rightBottomData[index].select = true;
              this.rightBottomData[0].select = false;
              this.rightBottomData[1].select = false;
              const { centlat, centlon, maplevel } = this.unitCenter;
              const maps = [
                "ywmap",
                "ywmap2",
                "vectormap",
                "terrain",
                "photomap",
              ];
              const mapIndex = maps.findIndex(
                (item) => item === unit.defaultmap
              );
              // 切换地图为业务图
              // this.selectMap(this.maps[0], 0);
              this.selectMap(this.maps[mapIndex], mapIndex);
              // 显示综合天气卡片
              const cardIndex = this.cartData.findIndex((v) =>
                v.types.includes(57)
              );
              if (cardIndex > -1) {
                this.changeCartShowHidden({
                  index: cardIndex,
                  show: true,
                });
              }
              if (objData.name === "世界黄皮公园") {
                this.map2d.map.getView().setCenter([111.5532992, 23.1243158]);
              } else {
                this.map2d.map.getView().setCenter([centlon, centlat]);
              }
              this.map2d.map.getView().setZoom(maplevel);
            }
          }
          break;
        case "right-top":
          if (component && component.wblink) {
            window.open(component.wblink, "_blank");
            return;
          }
          // 右上角选中筛选
          const data = this.rightTopData[index];
          if (this.selectRightTopData.includes(data.code)) {
            const index1 = this.selectRightTopData.findIndex(
              (code) => code === data.code
            );
            this.selectRightTopData.splice(index1, 1);
          } else {
            if (["A01", "A04"].includes(data.code)) {
              const code = data.code === "A01" ? "A04" : "A01";
              const index1 = this.selectRightTopData.findIndex(
                (item) => item === code
              );
              if (index1 > -1) {
                this.selectRightTopData.splice(index1, 1);
              }
            }
            this.selectRightTopData.push(data.code);
          }

          // 台风和卡片只能显示其中一个
          // if (this.selectRightTopData.includes('A02')) {
          //   this.changeAllCartShow(false)
          //   this.cardShow = true
          // } else if (data.code === 'A02') {
          //   this.changeAllCartShow(true)
          //   this.cardShow = false
          //   this.map2d.changeMap(0)
          // }
          // 执行原有的操作,通过执行component的方式
          const toggleData = ["A01", "A02", "A03", "A04", "A11", "A12", "A13"];
          console.log("data.code", data.code);
          toggleData.includes(data.code) && this.toggleProductView(data.code);

          // 风场直接在首页处理
          if (data.code === "A09") {
            this.selectRightTopData.includes("A09") &&
              this.map2d.map.getView().setZoom(6.3);
            this.selectRightTopData.includes("A09") && this.addWindyLayer();
            !this.selectRightTopData.includes("A09") &&
              this.windLayer.setVisible(false);
          }
          // 如果是要素则执行文字显示在地图上
          const fatarData = ["A05", "A06", "A07", "A08"];
          if (fatarData.includes(data.code)) {
            // this.drapText()
          }
          break;
        default:
          break;
      }
    },
    // 注册地图事件
    async mapLister() {
      // 地图鼠标移动事件
      this.map2d.map.on("pointermove", (ev) => {
        const coordinate = ev.coordinate; // [经度, 纬度]
        const lon = coordinate[0]; // 经度
        const lat = coordinate[1]; // 纬度
        this.mapLonLat = lon + "," + lat;
        const pixel = ev.pixel;
        const feature = this.map2d.map.forEachFeatureAtPixel(
          pixel,
          (feature) => {
            return feature;
          }
        );
        if (feature) {
          this.map2d.map.getTargetElement().style.cursor = "pointer";
          if (feature.get("point")) {
            const zoom = this.map2d.map.getView().getZoom();
            // if (zoom <= 12) {
            const { lon, lat } = feature.get("point");
            const index = feature.get("index");
            const pointType = feature.get("pointType");
            console.log("pointType", pointType);
            if (!pointType) {
              return;
            }
            // console.log('feature', feature)
            if (pointType === "obj") {
              const hoverPoint = feature.get("point");
              if (
                this.companyName === "佛山地铁" &&
                hoverPoint &&
                !this.isMetroPointVisible(hoverPoint.name)
              ) {
                return;
              }
              this.overlayer && this.overlayer.setPosition(undefined);
              this.overlayer = this.overlayerLayers[index];
              this.overlayerLayers[index].setPosition([lon, lat]);
            }
            if (pointType === "point") {
              this.dataPointOverlayer &&
                this.dataPointOverlayer.setPosition(undefined);
              this.dataPointOverlayer = this.dataPointOverlayerLayers[index];
              this.dataPointOverlayerLayers[index].setPosition([lon, lat]);
            }
            if (pointType === "zjz") {
              this.zjStationDataResultOverlayer &&
                this.zjStationDataResultOverlayer.setPosition(undefined);
              this.zjStationDataResultOverlayer =
                this.zjStationDataResultOverlayerLayers[index];
              this.zjStationDataResultOverlayerLayers[index].setPosition([
                lon,
                lat,
              ]);
            }
            // }
          }
          if (feature.get("mark")) {
            const point = feature.get("data");
            if (!point.rd07) {
              return;
            }
            console.log("points", point);

            const typhoonFeature = this.drawSolarExact(point);
            this.typhoonSource && this.typhoonSource.clear();
            if (!this.typhoonLayer1) {
              this.typhoonSource = new VectorSource();
              this.typhoonSource.addFeature(typhoonFeature);
              this.typhoonLayer1 = new VectorLayer({
                zIndex: 999,
                source: this.typhoonSource,
              });
              this.map2d.map.addLayer(this.typhoonLayer1);
              this.map2d.map.changed();
            } else {
              this.typhoonSource.addFeature(typhoonFeature);
              this.typhoonSource.changed();
            }
          }
          if (feature.get("thunder")) {
            const data = feature.get("data");
            const { lon, lat } = data;
            this.thunderData = data;
            this.thunderOverlayer.setPosition([lon, lat]);
          }
        } else {
          this.map2d.map.getTargetElement().style.cursor = "";
          const zoom = this.map2d.map.getView().getZoom();
          // if (zoom <= 12) {
          this.overlayer && this.overlayer.setPosition(undefined);
          // }
          this.dataPointOverlayer &&
            this.dataPointOverlayer.setPosition(undefined);
          this.zjStationDataResultOverlayer &&
            this.zjStationDataResultOverlayer.setPosition(undefined);
          this.typhoonSource &&
            this.typhoonSource.forEachFeature((feature) => {
              this.typhoonSource.removeFeature(feature);
            });
          this.thunderOverlayer && this.thunderOverlayer.setPosition(undefined);
        }
      });

      // 地图点击事件，显示对应的overlay
      this.map2d.map.on("singleclick", async (ev) => {
        const pixel = ev.pixel;
        const feature = this.map2d.map.forEachFeatureAtPixel(
          pixel,
          (feature) => {
            return feature;
          }
        );
        const { company } = this.$route.params;
        const { unit } = JSON.parse(localStorage.getItem(company));
        console.log("unit", unit);
        if (feature && feature.get("name")) {
          const point = feature.get("point");
          if (
            this.companyName === "佛山地铁" &&
            point &&
            !this.isMetroPointVisible(point.name)
          ) {
            return;
          }
          this.activePoint = point;
          // 不是二广高速才切换图标
          if (unit.id !== 8) {
            this.iconFeature.setStyle(this.mapIconColor(this.activePoint.r01h));
            this.activePoint = point;
            feature.setStyle(this.activeIconStyle);
            this.iconFeature = feature;
            feature.changed();
          }
          localStorage.setItem("activeCountyId", JSON.stringify(point.id));
          if (unit.town) {
            this.alarmArea = point.town;
          } else {
            this.alarmArea = point.county;
          }
          this.changeActiveCountyId(point.id);
        } else {
          const lon = (Math.round(ev.coordinate[1] / 0.05) * 0.05)
            .toFixed(2)
            .replace(/\./g, "");
          const lat = (Math.round(ev.coordinate[0] / 0.05) * 0.05)
            .toFixed(2)
            .replace(/\./g, "");
          const giftDataResult = await apiData.giftData(lat, lon);
          const { company } = this.$route.params;
          const { unit } = JSON.parse(localStorage.getItem(company));
          unit.id === 8 && this.$bus.$emit("changeForest", giftDataResult);
        }
        // 单位和数据点位点击处理
        if (feature && feature.get("pointType")) {
          const pointType = feature.get("pointType");
          const pointId = feature.get("pointId");
          // 自建站
          if (pointType === "zjz") {
            const labelid = unit.labelid;
            const zjzSlideLiveData = await apiData.querySlideLiveByZjz(
              pointId,
              24
            );
            const pointName = feature.get("pointName");
            zjzSlideLiveData.data.pointName = pointName;
            if (labelid === 4) {
              await this.loadProduct("ZjzSlideLiveScPopup");
            } else {
              await this.loadProduct("ZjzSlideLivePopup");
            }
            this.changCardData({
              type: "zjzSlideLiveData",
              data: zjzSlideLiveData.data,
            });
          }
        }
      });
      // 地图双击点击事件，显示对应的overlay
      this.map2d.map.on("dblclick", async (ev) => {
        // 阻止默认的双击缩放行为（可选）
        // 阻止默认的双击缩放行为
        if (this.doubleClickZoomInteraction) {
          this.doubleClickZoomInteraction.setActive(false);
        }
        console.log("ev", ev);
        const pixel = ev.pixel;
        const feature = this.map2d.map.forEachFeatureAtPixel(
          pixel,
          (feature) => {
            return feature;
          }
        );
        // 单位和数据点位点击处理
        if (feature && feature.get("pointType")) {
          const pointType = feature.get("pointType");
          const pointId = feature.get("pointId");
          // 自建站
          console.log("pointType", pointType);
          console.log("pointId", pointId);
          const pointName = feature.get("pointName");
          const pointSlideLiveData = await apiData.sildeLive(
            pointId,
            24,
            pointType,
          );
          pointSlideLiveData.pointName = pointName;
          // 弹窗展示数据
          await this.loadProduct("PointSlideLivePopup");
          this.changCardData({
            type: "pointSlideLiveData",
            data: pointSlideLiveData.data,
          });
        }
      });

      // 地图缩放
      this.map2d.map.getView().on("change:resolution", () => {
        const zoom = this.map2d.map.getView().getZoom();
        if (this.companyName === "佛山地铁") {
          this.updateMetroThinning();
        } else if (zoom > 12) {
          this.showOverlayer(this.overlayerLayers);
          // this.showOverlayer(this.dataPointOverlayerLayers)
          // this.showOverlayer(this.zjStationDataResultOverlayerLayers)
        } else {
          this.hiddenOverlayer(this.overlayerLayers);
          // this.hiddenOverlayer(this.dataPointOverlayerLayers)
          // this.hiddenOverlayer(this.zjStationDataResultOverlayerLayers)
        }
        // 单位边界图片显示
        if (this.maplevel && this.jhwImagelayer !== "") {
          if (zoom > 11) {
            this.jhwImagelayer.setVisible(true);
          } else {
            this.jhwImagelayer.setVisible(false);
          }
        }
        // 数据站点和自建站显示
        if (zoom > 11) {
          this.dataPointLayer && this.dataPointLayer.setVisible(true);
          this.zjPointLayer && this.zjPointLayer.setVisible(true);
        } else {
          this.dataPointLayer && this.dataPointLayer.setVisible(false);
          this.zjPointLayer && this.zjPointLayer.setVisible(false);
        }
        this.scaleImage(this.textSource, zoom);
        this.scaleImage(this.dataPointSource, zoom);
        this.scaleImage(this.zjPointSource, zoom);
        if (this.companyName === "佛山地铁") {
          this.applyMetroFactVisibility();
        }
      });
      this.map2d.map.on("moveend", () => {
        if (this.companyName === "佛山地铁") {
          this.updateMetroThinning(true);
        }
      });
    },
    scaleImage(source, zoom) {
      if (source) {
        const features = source.getFeatures();
        for (let i = 0; i < features.length; i++) {
          let radio = 45;
          const wind = features[i].get("wind");
          if (wind) {
            radio = 18;
          }
          const style = features[i].getStyle();
          if (style && style.getImage()) {
            const styleImage = style.getImage();
            style.getImage().setScale(zoom / radio);
            features[i].setStyle(style);
          }
        }
      }
    },
    showOverlayer(overlayers) {
      overlayers.forEach((overlayerLayer) => {
        const { lon, lat } = overlayerLayer.options.data;
        const index = overlayerLayer.options.index;

        // ✅ 佛山地铁：检查这个 Overlay 是否应该显示（路线过滤 + 抽稀）
        if (this.companyName === "佛山地铁") {
          const data = overlayerLayer.options.data;
          if (data && data.name && !this.isMetroPointVisible(data.name)) {
            return;
          }
        }

        overlayers[index].setPosition([lon, lat]);
      });
    },
    hiddenOverlayer(overlayers) {
      overlayers.forEach((overlayerLayer) => {
        const index = overlayerLayer.options.index;
        overlayers[index].setPosition(undefined);
      });
    },
    async listenerBusElement() {
      this.$bus.$on("showUltravioletRays", (data) => {
        this.loadProduct("UltravioletRaysPopup");
      });
      this.$bus.$on("showSevenDayForecast", (data) => {
        this.toggleProductView("C16");
      });
      this.$bus.$on("showSevenDayRiskForecast", (data) => {
        this.loadProduct("SevenDayRiskForecastPopup");
      });
      this.$bus.$on("showWaterTempChart", (data) => {
        this.loadProduct("WaterTemperatureLivePopup");
      });
      this.$bus.$on("factsElement", (data) => {
        console.log("factsElement", data);
        this.drapFactsText(data);
      });
    },
    /**
     * return feature
     */
    drawSolarExact: function (points) {
      const feature = new Feature({
        geometry: new Circle([
          Number(points.longitude),
          Number(points.latitude),
        ]),
      });

      // 🎯 颜色配置与参考代码 levels 完全一致
      const windCircleConfigs = [
        { key: "rd12", color: "#FF0000" },
        { key: "rd10", color: "#F59A23" },
        { key: "rd08", color: "#FFFF00" },
        { key: "rd07", color: "#0000FF" },
        { key: "rd06", color: "#00FF00" },
      ];

      const validCircles = windCircleConfigs
        .map((config) => {
          const rawData = points[config.key];
          if (!rawData || typeof rawData !== "string") return null;

          const rd = rawData.split(",").map(Number);
          if (rd.length !== 4 || rd.some(isNaN)) return null;

          return {
            strokeColor: config.color,
            // 🎯 数据顺序与参考代码完全一致：NE, SE, SW, NW
            // 🎯 单位转换与参考代码完全一致：turf.lengthToDegrees
            radius: {
              NE: turf.lengthToDegrees(rd[0]),
              SE: turf.lengthToDegrees(rd[1]),
              SW: turf.lengthToDegrees(rd[2]),
              NW: turf.lengthToDegrees(rd[3]),
            },
          };
        })
        .filter(Boolean);

      if (validCircles.length === 0) {
        feature.setStyle(new Style({ renderer() { } }));
        return feature;
      }

      feature.setStyle(
        new Style({
          renderer(coordinates, state) {
            const ctx = state.context;
            const [x, y] = coordinates[0];

            validCircles.forEach((circle) => {
              ctx.beginPath();

              // 🎯 Canvas 中 OpenLayers 的像素坐标 Y 轴向下
              // 因此需要将地理角度取反才能正确映射到屏幕象限
              // 地理 NE (0°-90°) → Canvas 第四象限 (270°-360° / -90°-0°)
              let distance = circle.radius.NE / state.resolution;
              ctx.arc(x, y, distance, -0.5 * Math.PI, 0);

              // 地理 NW (90°-180°) → Canvas 第三象限 (180°-270° / -180°--90°)
              distance = circle.radius.NW / state.resolution;
              ctx.arc(x, y, distance, -1.0 * Math.PI, -0.5 * Math.PI);

              // 地理 SW (180°-270°) → Canvas 第二象限 (90°-180° / -270°--180°)
              distance = circle.radius.SW / state.resolution;
              ctx.arc(x, y, distance, -1.5 * Math.PI, -1.0 * Math.PI);

              // 地理 SE (270°-360°) → Canvas 第一象限 (0°-90° / -360°--270°)
              distance = circle.radius.SE / state.resolution;
              ctx.arc(x, y, distance, -2.0 * Math.PI, -1.5 * Math.PI);

              ctx.closePath();
              ctx.strokeStyle = circle.strokeColor;
              ctx.lineWidth = 1.5;
              ctx.stroke();
            });
          },
        })
      );

      return feature;
    },
    // 跳转至决策服务
    goToService() {
      const isProduction = process.env.NODE_ENV === "production";
      let baseUrl = "";

      if (isProduction) {
        baseUrl = "https://www.fspms.cn/fshy";
      } else {
        baseUrl = ""; // 本地开发时可用相对路径
      }

      const company = this.$route.params.company;
      const fullPath = `${baseUrl}/#/${company}/liveData`;
      window.open(fullPath, "_blank");
    },
    // 跳转至数据中心
    goToDataCenter() {
      const company = this.$route.params.company;
      const routeUrl = this.$router.resolve({
        name: "DataCenter",
        query: { company: company },
      });
      window.open(routeUrl.href, "_blank");
    },

    /**
     * 退出
     */
    async logout() {
      const token = sessionStorage.getItem("token");
      const { status } = await apiData.logout(JSON.parse(token));
      if (status === 200) {
        this.$message({
          message: "退出成功！",
          type: "success",
        });
        const company = this.$route.params.company;
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push({
          name: "Login",
          params: { company },
        });
      } else {
        this.$message("退出失败，请联系管理员！");
      }
    },

    // 点击清除动画
    clearAnimation(filed) {
      this[filed] = false;
    },
    /**
     * 警戒线
     */
    warnScope() {
      if (this.unitObjs.length === 0) {
        return;
      }
      let geometry;
      if (this.unitObjs.length === 1) {
        let p;
        // 暂时对云浮单位额外处理
        if (this.unitObjs[0].name === "世界黄皮公园") {
          p = point([111.5532992, 23.1243158]);
        } else {
          p = point([this.unitObjs[0].lon, this.unitObjs[0].lat]);
        }
        geometry = p.geometry;
      } else if (this.unitObjs.length === 2) {
        const line = lineString([
          [this.unitObjs[0].lon, this.unitObjs[0].lat],
          [this.unitObjs[1].lon, this.unitObjs[1].lat],
        ]);
        geometry = line.geometry;
      } else {
        const points = [];
        this.unitObjs.forEach((element) => {
          points.push(point([element.lon, element.lat]));
        });
        const convex = turfConvex(featureCollection(points));
        geometry = convex.geometry;
      }
      const km20 = turfBuffer(geometry, 20);
      const km50 = turfBuffer(geometry, 50);
      const km80 = turfBuffer(geometry, 80);
      const feature0 = new Feature({
        geometry: new Polygon(km20.geometry.coordinates),
      });
      const feature1 = new Feature({
        geometry: new Polygon(km50.geometry.coordinates),
      });
      const feature2 = new Feature({
        geometry: new Polygon(km80.geometry.coordinates),
      });
      const features = [feature0, feature1, feature2];
      const arr = ["20", "50", "80"];
      arr.forEach((item, index) => {
        const cente1 = features[index]
          .getGeometry()
          .getLinearRings()[0]
          .getCoordinates()[0];
        const featureText = new Feature({
          geometry: new Point(cente1),
        });
        featureText.setStyle(
          new Style({
            text: new Text({
              text: `${item}km`,
              scale: 1.5,
              offsetX: 0,
              fill: new Fill({
                color: "#e89f27",
              }),
            }),
          })
        );
        features.push(featureText);
      });

      this.warnLayer = new VectorLayer({
        source: new VectorSource({
          features: features,
        }),
        style: [
          new Style({
            stroke: new Stroke({
              color: "#e89f27",
              lineDash: [10, 5],
              width: 2,
            }),
          }),
        ],
        zIndex: 9,
      });
      this.map2d.map.addLayer(this.warnLayer);
    },
    async addWindyLayer() {
      this.windLayer && this.map2d.map.removeLayer(this.windLayer);
      const gfsTime = await apiData.queryFsTfWindTimeData();
      const startTime = gfsTime.startTime;
      const forecastTime = gfsTime.leadtimes;
      const refTime = this.parseCustomDateFormat(startTime);
      const timeStr = refTime.format("YYYYMMDDHH");
      const now = this.$moment(new Date());
      const diffInMilliseconds = now.diff(refTime);
      // 将毫秒转换为小时
      const diffInHours = Number(
        diffInMilliseconds / (1000 * 60 * 60).toFixed(0)
      );
      let hours = (Math.floor(diffInHours / 3) * 3).toFixed(0);
      if (Number(hours) > forecastTime[forecastTime.length - 1]) {
        hours = String(forecastTime[forecastTime.length - 1]);
      }
      const leadtime = hours.padStart(3, "0");
      const gfsRes = await apiData.queryFsTfWindData(timeStr, leadtime);
      const gfsData = gfsRes.data;
      const bounds = [60, 60, 0, 150];
      const u = gfsData[0];
      const v = gfsData[1];
      const headers = {
        lo1: bounds[1],
        la1: bounds[0],
        lo2: bounds[3],
        la2: bounds[2],
        ...gfsRes.header,
      };
      const val = [
        {
          header: {
            ...headers,
            parameterCategory: 2,
            parameterNumber: 2,
          },
          data: u,
        },
        {
          header: {
            ...headers,
            parameterCategory: 2,
            parameterNumber: 3,
          },
          data: v,
        },
      ];
      const windLayer = new WindLayer(val, {
        foceRender: false,
        zIndex: 99,
        windOptions: {
          globalAlpha: 0.9, // 粒子透明度
          maxAge: 10, // 存活最大帧数
          velocityScale: 1 / 50, // 粒子速度
          frameRate: 200, // 每50贞绘制一次
          width: 400,
          paths: (wind) => {
            let paths = 4000;
            if (wind > 12) {
              paths = 7000;
            } else if (wind > 9) {
              paths = 6000;
            } else if (wind > 7) {
              paths = 5000;
            }
            return paths;
          }, // 粒子数量
          colorScale: ["rgb(255, 255, 255)"],
          lineWidth: (wind) => {
            let width = 0.5;
            if (wind > 12) {
              width = 1.5;
            } else if (wind > 7) {
              width = 0.8;
            }
            return width;
          },
        },
      });
      this.windLayer = windLayer;
      this.map2d.map.addLayer(windLayer);
    },
    parseCustomDateFormat(dateString) {
      // 确保输入字符串长度为 12（YYYYMMDDHH）
      if (dateString.length !== 10) {
        throw new Error("Invalid date format");
      }
      // 解析字符串到年、月、日、时
      const year = parseInt(dateString.substr(0, 4), 10);
      const month = parseInt(dateString.substr(4, 2), 10) - 1; // 注意：JavaScript 中的月份是从 0 开始的
      const day = parseInt(dateString.substr(6, 2), 10);
      const hour = parseInt(dateString.substr(8, 2), 10);
      // 使用 Moment.js 创建一个日期对象
      return this.$moment({
        year,
        month,
        day,
        hour, // 如果没有分钟和秒，它们默认为 0
      });
    },
    // 添加风场
    // async addWindyLayer () {
    //   this.windLayer && this.map2d.map.removeLayer(this.windLayer)
    //   const gfsTime = await apiData.querySzTfWindTimeData()
    //   const forecastTime = gfsTime.forecastTime
    //   const refTime = this.$moment(gfsTime.refTime)
    //   const timeStr = refTime.format('YYYYMMDDHH')
    //   const now = this.$moment(new Date())
    //   const diffInMilliseconds = now.diff(refTime)
    //   // 将毫秒转换为小时
    //   const diffInHours = Number(diffInMilliseconds / (1000 * 60 * 60).toFixed(0))
    //   let hours = (Math.floor((diffInHours / 3)) * 3).toFixed(0)
    //   if (Number(hours) > forecastTime[forecastTime.length - 1]) {
    //     hours = String(forecastTime[forecastTime.length - 1])
    //   }
    //   const leadtime = hours.padStart(3, '0')
    //   const gfsRes = await apiData.querySzTfWindData(timeStr, leadtime)
    //   const gfs = gfsRes.data
    //   const bounds = gfs.header.bounds
    //   const u = gfs.data[0]
    //   const v = gfs.data[1]
    //   const headers = {
    //     lo1: bounds[1],
    //     la1: bounds[0],
    //     lo2: bounds[3],
    //     la2: bounds[2],
    //     ...gfs.header
    //   }
    //   const val = [{ header: { ...headers, parameterCategory: 2, parameterNumber: 2 }, data: u }, { header: { ...headers, parameterCategory: 2, parameterNumber: 3 }, data: v }]
    //   const windLayer = new WindLayer(val, {
    //     foceRender: false,
    //     zIndex: 99,
    //     windOptions: {
    //       globalAlpha: 0.9, // 粒子透明度
    //       maxAge: 10, // 存活最大帧数
    //       velocityScale: 1 / 20, // 粒子速度
    //       frameRate: 200, // 每50贞绘制一次
    //       width: 300,
    //       paths: (wind) => {
    //         let paths = 4000
    //         if (wind > 12) {
    //           paths = 7000
    //         } else if (wind > 9) {
    //           paths = 6000
    //         } else if (wind > 7) {
    //           paths = 5000
    //         }
    //         return paths
    //       }, // 粒子数量
    //       colorScale: ['rgb(85, 85, 85)', 'rgb(95, 95, 95)', 'rgb(105, 105, 105)', 'rgb(115, 115, 115)', 'rgb(125, 125, 125)', 'rgb(135, 135, 135)', 'rgb(145, 145, 145)', 'rgb(155, 155, 155)', 'rgb(165, 165, 165)', 'rgb(175, 175, 175)', 'rgb(185, 185, 185)', 'rgb(195, 195, 195)', 'rgb(205, 205, 205)', 'rgb(215, 215, 215)', 'rgb(225, 225, 225)', 'rgb(235, 235, 235)', 'rgb(245, 245, 245)', 'rgb(255, 255, 255)'],
    //       lineWidth: (wind) => {
    //         let width = 0.5
    //         if (wind > 12) {
    //           width = 1.5
    //         } else if (wind > 7) {
    //           width = 0.8
    //         }
    //         return width
    //       }
    //     }
    //   })
    //   this.windLayer = windLayer
    //   this.map2d.map.addLayer(windLayer)
    // },
    // 获取自动站列表
    async getGiftLive() {
      const { company } = this.$route.params;
      const { unit } = JSON.parse(localStorage.getItem(company));
      this.tableData = [];
      const wheatherLiveResult = await apiData.queryWheatherLiveDataByUnitid(
        unit.id
      );
      console.log("wheatherLiveResult", wheatherLiveResult);
      this.unitObjs.forEach(async (point, index) => {
        const tqskDateResult = wheatherLiveResult.data.find(
          (item) => item.objid === point.id
        );
        if (tqskDateResult) {
          tqskDateResult.temp =
            tqskDateResult.t > 0 ? tqskDateResult.t.toFixed(1) : "";
          tqskDateResult.winds = tqskDateResult.wd2df;
          tqskDateResult.windd = tqskDateResult.wd2dd;
          tqskDateResult.timeLong = tqskDateResult.ddatetime;
          tqskDateResult.winds = tqskDateResult.wd2df;
          tqskDateResult.p =
            tqskDateResult.p > 0 ? tqskDateResult.p.toFixed(1) : "";
          tqskDateResult.rh =
            tqskDateResult.rh > 0 ? tqskDateResult.rh.toFixed(1) : "";
          const pointObj = { ...point, ...tqskDateResult };
          // console.log("pointObj", pointObj);
          this.tableData.push(pointObj);
        }
      });

      this.$nextTick(() => {
        setTimeout(() => {
          this.drawICon();
          this.drapFactsText(["temp", "windd_dir", "r01h", "rh", "light"]);
        }, 1000);
      });
    },
    /**
     * 画出实况数据
     */
    drapFactsText(showElements) {
      // 画单位对象
      this.showUnitData(showElements);
      this.showDataPointData(showElements);
      this.showUnitZjStationData(showElements);
      if (this.companyName === "佛山地铁") {
        this.applyMetroFactVisibility();
      }
    },
    showUnitData(showElements) {
      if (!this.textLayer) {
        this.textSource = new VectorSource();
        this.textLayer = new VectorLayer({
          zIndex: 99999,
          source: this.textSource,
        });
        this.map2d.map.addLayer(this.textLayer);
      }
      this.textSource.clear();
      const features = [];
      const isFSMetro = this.companyName === "佛山地铁";
      showElements.forEach((type) => {
        this.tableData.forEach((item) => {
          if (isFSMetro) {
            const routeName = this.stationRouteMap[item.name];
            if (routeName && !this.selectedRoutes.includes(routeName)) {
              return; // 跳过这个点位
            }
          }
          if (type === "r01h" && item.hourrf === 0) {
            // eslint-disable-next-line no-constant-condition
            // if (false) {
          } else {
            const positon = [item.lon, item.lat];
            const feature = new Feature({ geometry: new Point(positon) });
            feature.set("pointName", item.name);
            // 除了风速风向的元素处理
            if (!["windd_dir"].includes(type)) {
              let text = item[type] + "";
              if (
                ["-999.9", "9999", "undifined", "null", "undefined"].includes(
                  text
                ) ||
                Number(text) < 0
              ) {
                text = "";
              }
              text = text + this.getFieldUnit(text, type);
              const style = new Style({
                text: new Text({
                  text: text,
                  font: "0.9vw  sans-serif",
                  fill: new Fill({
                    color: "white",
                  }),
                  offsetX:
                    type === "temp"
                      ? -30
                      : type === "rh"
                        ? -30
                        : type === "r01h"
                          ? -30
                          : type === "p"
                            ? 45
                            : 33,
                  offsetY:
                    type === "temp"
                      ? -15
                      : type === "rh"
                        ? 0
                        : type === "r01h"
                          ? 15
                          : type === "p"
                            ? 0
                            : -15,
                }),
              });
              feature.setStyle(style);
            } else {
              let rotation = 0;
              rotation =
                (parseFloat(item.windd_dir ? item.windd_dir : item.wd2dd) *
                  Math.PI) /
                180;
              if (!this.windBarb) {
                this.windBarb = new WindBarb(10);
              }
              const img = this.windBarb.getIconOfCanvas(3);
              const style = new Style({
                image: new Icon({
                  img: img,
                  imgSize: [13, 26],
                  anchor: [-20, 1],
                  anchorXUnits: "pixels",
                  rotation: rotation,
                }),
              });
              feature.setStyle(style);
              feature.set("wind", true);
            }
            features.push(feature);
          }
        });
      });
      this.textSource.addFeatures(features);
      this.textSource.changed();
    },
    showDataPointData(showElements) {
      if (!this.dataPointLayer) {
        this.dataPointSource = new VectorSource();
        this.dataPointLayer = new VectorLayer({
          zIndex: 99999,
          source: this.dataPointSource,
        });
        this.map2d.map.addLayer(this.dataPointLayer);
      }
      const features = [];
      this.dataPointSource.clear();
      const unitPointDataResult = this.unitPointDataResult || [];
      // console.log("unitPointDataResult", unitPointDataResult);
      this.removeDataPointOverLayers();
      const dataPointMap = {
        temp: "t",
        r01h: "r01h",
        windd_dir: ["wd2dd", "wd2df"],
        rh: "rh",
        p: "p",
        light: "light",
      };
      if (showElements && showElements.length > 0) {
        // 画出数据点位
        unitPointDataResult.forEach((item, index) => {
          const positon = [item.lon, item.lat];
          const feature = new Feature({ geometry: new Point(positon) });
          feature.set("pointType", "point");
          feature.set("pointId", item.pointid);
          feature.set("pointName", item.pname);
          feature.set("pointName", item.pname);
          feature.set("point", {
            lon: item.lon,
            lat: item.lat,
          });
          feature.set("index", index);
          const style = new Style({
            image: new Icon({
              src: require("@/assets/images/data_point_icon.png"),
              scale: 0.35,
            }),
          });
          feature.setStyle(style);
          features.push(feature);
        });
      }
      const isFSMetro = this.companyName === "佛山地铁";
      // 画数据点位对象
      showElements.forEach((type) => {
        const el = dataPointMap[type];
        unitPointDataResult.forEach((item, index) => {
          if (isFSMetro) {
            const routeName = this.stationRouteMap[item.pname];
            if (routeName && !this.selectedRoutes.includes(routeName)) {
              return; // 跳过这个点位
            }
          }
          if (type === "r01h" && item[el] === 0) {
          } else {
            const positon = [item.lon, item.lat];
            const feature = new Feature({ geometry: new Point(positon) });
            feature.set("pointName", item.pname);

            // 除了风速风向的元素处理
            if (!["windd_dir"].includes(type)) {
              let text = item[el] + "";
              // console.log("el-text", text);
              if (
                ["-999.9", "9999", "undifined", "null", "undefined"].includes(
                  text
                )
              ) {
                text = "";
              }
              text = text + this.getFieldUnit(text, type);
              const style = new Style({
                text: new Text({
                  text: text,
                  font: "0.65vw  sans-serif",
                  fill: new Fill({
                    color: "white",
                  }),
                  offsetX:
                    type === "temp"
                      ? -30
                      : type === "rh"
                        ? -30
                        : type === "r01h"
                          ? -30
                          : type === "p"
                            ? 45
                            : 33,
                  offsetY:
                    type === "temp"
                      ? -15
                      : type === "rh"
                        ? 0
                        : type === "r01h"
                          ? 15
                          : type === "p"
                            ? 0
                            : -15,
                }),
              });
              feature.setStyle(style);
            } else {
              if (showElements.length === 1) {
                // 画出风的数据点位
                const pointFeature = new Feature({
                  geometry: new Point(positon),
                });
                pointFeature.set("pointName", item.pname);
                const pointStyle = new Style({
                  image: new Icon({
                    src: require("@/assets/images/data_point_icon.png"),
                    scale: 0.35,
                  }),
                });
                pointFeature.setStyle(pointStyle);
                features.push(pointFeature);
              }
              let rotation = 0;
              rotation = (parseFloat(item.wd2dd) * Math.PI) / 180;
              if (!this.windBarb) {
                this.windBarb = new WindBarb(10);
              }
              const img = this.windBarb.getIconOfCanvas(3);
              const style = new Style({
                image: new Icon({
                  img: img,
                  imgSize: [13, 26],
                  anchor: [-20, 1],
                  anchorXUnits: "pixels",
                  rotation: rotation,
                }),
              });
              feature.setStyle(style);
              feature.set("wind", true);
            }
            features.push(feature);
          }
          this.addDataPointOverLayers(item, index);
        });
      });
      this.dataPointSource.addFeatures(features);
      this.dataPointSource.changed();
    },
    showUnitZjStationData(showElements) {
      if (!this.zjPointLayer) {
        this.zjPointSource = new VectorSource();
        this.zjPointLayer = new VectorLayer({
          zIndex: 99999,
          source: this.zjPointSource,
        });
        this.map2d.map.addLayer(this.zjPointLayer);
      }
      this.zjPointSource.clear();
      const features = [];
      // 画自建站点对象
      const unitZjStationDataResult = this.unitZjStationDataResult || [];
      this.removezjStationDataOverLayers();
      if (showElements && showElements.length > 0) {
        // 画出数据点位
        unitZjStationDataResult.forEach((item, index) => {
          const positon = [item.lon, item.lat];
          const feature = new Feature({ geometry: new Point(positon) });
          feature.set("pointType", "zjz");
          feature.set("pointId", item.staid);
          feature.set("pointName", item.staname);
          feature.set("point", {
            lon: item.lon,
            lat: item.lat,
          });
          feature.set("index", index);
          const style = new Style({
            image: new Icon({
              src: require("@/assets/images/zj_station_icon_v2.png"),
              scale: 0.28,
            }),
          });
          feature.setStyle(style);
          features.push(feature);
        });
      }

      const zjStationDataMap = {
        temp: "t",
        r01h: "r01h",
        windd_dir: ["wd2dd", "wd2df"],
        rh: "rh",
        p: "p",
        light: "light",
      };
      const isFSMetro = this.companyName === "佛山地铁";
      showElements.forEach((type) => {
        const el = zjStationDataMap[type];
        if (el) {
          unitZjStationDataResult.forEach((item, index) => {
            if (isFSMetro) {
              const routeName = this.stationRouteMap[item.staname];
              if (routeName && !this.selectedRoutes.includes(routeName)) {
                return; // 跳过这个点位
              }
            }
            if (type === "r01h" && item[el] === 0) {
            } else {
              const positon = [item.lon, item.lat];
              const feature = new Feature({ geometry: new Point(positon) });
              feature.set("pointName", item.staname);
              // 除了风速风向的元素处理
              if (!["windd_dir"].includes(type)) {
                let text = item[el] + "";
                // console.log("el-text", text);
                if (
                  ["-999.9", "9999", "undifined", "null", "undefined"].includes(
                    text
                  )
                ) {
                  text = "";
                }
                text = text + this.getFieldUnit(text, type);
                const style = new Style({
                  text: new Text({
                    text: text,
                    font: "0.65vw  sans-serif",
                    fill: new Fill({
                      color: "white",
                    }),
                    offsetX:
                      type === "temp"
                        ? -30
                        : type === "rh"
                          ? -30
                          : type === "r01h"
                            ? -30
                            : type === "p"
                              ? 45
                              : 33,
                    offsetY:
                      type === "temp"
                        ? -15
                        : type === "rh"
                          ? 0
                          : type === "r01h"
                            ? 15
                            : type === "p"
                              ? 0
                              : -15,
                  }),
                });
                feature.setStyle(style);
              } else {
                if (showElements.length === 1) {
                  // 画出风的数据点位
                  const pointFeature = new Feature({
                    geometry: new Point(positon),
                  });
                  pointFeature.set("pointName", item.staname);
                  const pointStyle = new Style({
                    image: new Icon({
                      src: require("@/assets/images/data_point_icon.png"),
                      scale: 0.35,
                    }),
                  });
                  pointFeature.setStyle(pointStyle);
                  features.push(pointFeature);
                }
                let rotation = 0;
                rotation = (parseFloat(item.wd2dd) * Math.PI) / 180;
                if (!this.windBarb) {
                  this.windBarb = new WindBarb(10);
                }
                const img = this.windBarb.getIconOfCanvas(3);
                const style = new Style({
                  image: new Icon({
                    img: img,
                    imgSize: [13, 26],
                    anchor: [-20, 1],
                    anchorXUnits: "pixels",
                    rotation: rotation,
                  }),
                });
                feature.setStyle(style);
                feature.set("wind", true);
              }
              features.push(feature);
            }
            this.addZjStationDataOverLayers(item, index);
          });
        }
      });
      this.zjPointSource.addFeatures(features);
      this.zjPointSource.changed();
    },
    // 获取元素单位
    getFieldUnit(text, type) {
      if (!text || !type) {
        return "";
      }
      const units = {
        temp: "℃",
        hourrf: "mm",
        windd_dir: "",
        rh: "%",
        p: "hPa",
        light: "lux",
      };
      const unit = units[type];
      if (!unit) {
        return "";
      }
      return unit;
    },
    // 中间按钮的点击
    moveToolPosition(type) {
      const el = this.$refs.contentBoxRef;
      const contentWrapWidth = el.scrollWidth;
      const contentBoxEl = this.$refs.contentBoxRef;
      const contentBoxWidth = contentBoxEl.offsetWidth;
      const maxMoveWidth = contentWrapWidth - contentBoxWidth;
      if (type === "right" && el.scrollLeft < maxMoveWidth) {
        const left = el.scrollLeft + contentBoxWidth;
        el.scrollTo({
          left,
          behavior: "smooth",
        });
      } else {
        const left = el.scrollLeft - contentBoxWidth;
        el.scrollTo({
          left,
          behavior: "smooth",
        });
      }
    },

    isShowCard() {
      this.cardShow = !this.cardShow;
      this.changeAllCartShow(!this.cardShow);
    },
    /**
     * 设置白云山图片叠加到地图
     */
    setSource() {
      if (this.Imagelayer === "") {
        this.Imagelayer = new ImageLayer({
          zIndex: 10,
          opacity: 1,
        });
        this.map2d.map.addLayer(this.Imagelayer);
      }
      const source = new ImageStatic({
        url: require("@/assets/images/白云山.png"),
        imageExtent: [113.242194, 23.125749, 113.351285, 23.235911],
      });
      this.Imagelayer.setSource(source);
    },

    // 右侧滚动
    moveTopRightTool() {
      const el = this.$refs.topWrapRef;
      const left = el.scrollLeft;
      const offsetWidth = el.offsetWidth;
      const scrollWidth = el.scrollWidth - el.offsetWidth;
      if (left < scrollWidth - 5) {
        this.$refs.topWrapRef.scrollTo({
          left: left + offsetWidth,
          behavior: "smooth",
        });
      } else {
        this.$refs.topWrapRef.scrollTo({
          left: left - offsetWidth,
          behavior: "smooth",
        });
      }
    },
    // 地铁预警预报
    async queryMetroAlertForecast() {
      const isFSMetro = this.companyName === "佛山地铁";
      if (!isFSMetro) return;
      const res = await apiData.queryMetroAlertForecast();
      if (res.status === 200) {
        this.showMetroAlertDialog = res.data.popup;
        this.metroAlertForecast = res.data;
      }
      console.log("res", res);
    },
    async queryRealTimeAlarm() {
      const isFSMetro = this.companyName === "佛山地铁";
      if (!isFSMetro) return;
      const res = await apiData.queryRealTimeAlarm();
      if (res.status === 200) {
        this.showRealTimeAlarmDialog = res.data.popup;
        this.realTimeAlarm = res.data;
      }
    },
  },
  beforeDestroy() {
    this.timmer && clearInterval(this.timmer);
  },

  components: {
    Card1,
    Card2,
    Card3,
    Card4,
    Card5,
    Card6,
    ThunderOverlayer,
    CardConfig,
    MetroAlertDialog,
    RealTimeAlarmDialog,
  },
};
</script>
<style lang="less">
.home {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  .header {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    z-index: 3;
    width: 100%;
    height: 11vh;
    // max-height:9vh;
    box-sizing: border-box;
    //background: url("../assets/images/头部背景.png") no-repeat;
    background: url("../assets/images/header_bg.png") no-repeat;
    background-size: 100% auto;
    background-position: top;
    border: 0;
    display: flex;

    .tool {
      width: 6.38rem;
      height: 100%;
      max-width: 102px;
      background: url("../assets/images/工具箱背景.png") no-repeat;
      background-size: cover !important;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        display: inline-block;
        width: 1rem;
        height: 0.75rem;
        max-width: 16px;
        max-height: 12px;
        background: url("../assets/images/工具箱.png") no-repeat;
        background-size: cover !important;
      }

      span {
        color: #ffffff;
        font-size: 1rem;
      }
    }

    .header-inner {
      flex: 1;
      display: flex;
      align-items: center;
      // box-shadow: 0rem 0.94rem 0.88rem 0rem rgba(234, 234, 234, 0.5);
      position: relative;
      box-sizing: border-box;
      padding-bottom: 20px;
      z-index: 1;

      .logo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0.6vh;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.67vw;
        font-weight: 600;
        color: #fff;
        text-align: center;
        line-height: 2.34vw;

        .company-name {
          font-size: 1.5vw;
          font-weight: 400;
          line-height: 1.7vw;
          text-shadow: 0px 2px 4px rgba(1, 37, 89, 0.6);
          margin-bottom: 0.2vw;
        }

        .sys-name-main {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            width: 0.4vw;
            height: 0.6vw;
            margin-top: 0.2vw;
          }

          .sys-name {
            margin: 0 0.6vw;
            font-size: 0.9vw;
            font-weight: 400;
            line-height: 1.46vw;
          }
        }

        // margin: 0 1.31rem 0 2.38rem;
        //span:nth-child(2) {
        //  font-size: 1.04vw;
        //  font-weight: 400;
        //  line-height: 1.46vw;
        //}
      }

      .sys_logo {
        position: absolute;
        top: 1.5vh;
        left: 71%;
        width: 10vw;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .warning {
        padding-left: 1rem;
        color: #fff;
        cursor: pointer;

        img {
          width: 3.44rem;
          max-width: 55px;
          margin-right: 0.56rem;
        }
      }

      .header-right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .now {
          display: flex;
          flex-direction: column;
          padding-right: 1.2rem;
          text-align: right;
          font-size: 1rem;
          color: #fff;

          i {
            display: block;
            width: 0.06rem;
            height: 0.94rem;
            background-color: #d1d1d1;
          }

          strong {
            font-size: 1.38rem;
            font-weight: 600;
            color: #fff;
          }
        }

        .back-btn {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          width: 6.51vw;
          height: 2.19vw;
          padding-left: 0.78vw;
          font-size: 0.83vw;
          font-weight: 600;
          color: #ffffff;
          cursor: pointer;
          pointer-events: auto;
          background: url("../assets/images/返回布局框.png") no-repeat;
          background-size: 100% 100%;

          img {
            width: 1.77vw;
          }
        }

        .menu {
          display: flex;
          align-items: center;

          .menu-item {
            position: relative;

            img {
              max-width: 23px;
              width: 1.44rem;
              cursor: pointer;
            }
          }

          .line {
            width: 0.05vw;
            height: 0.57vw;
            margin: 0 1rem;
            background: rgba(255, 255, 255, 0.3);
          }

          .line1 {
            height: 1.09vw;
          }
        }
      }
    }

    .right-top-tool {
      display: flex;
      position: absolute;
      top: 89%;
      right: 0;
      z-index: 2;
      width: 32.86vw;
      height: 6vh;
      overflow: hidden;
      box-sizing: border-box;
      max-height: 6vh;
      box-sizing: border-box;
      padding: 0vw 0.5vw 0.52vw 2.3vw;
      background: url("../assets/images/head_right_bg.png") no-repeat;
      background-size: 100%;
      background-position: bottom;
      // &::-webkit-scrollbar {
      //   width: 0;
      //   height: 0;
      // }

      .right-btn {
        position: absolute;
        right: 0.52vw;
        top: 0.4vw;
        width: 1.8vw;
        height: auto;
        cursor: pointer;
      }

      .top-wrap {
        display: flex;
        justify-content: space-between;
        flex: 1;
        overflow: hidden;
        overflow-y: auto;

        .top-cont {
          display: flex;
          justify-content: space-between;
          flex: 1;
          // float: left;
        }
      }

      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.4vw;
        height: 2.4vw;
        max-height: 100%;
        // margin-right: .6vw;
        cursor: pointer;

        img {
          width: 1.35vw;
        }
      }

      .image.active {
        background: url("../assets/images/选择.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .left-top-tool {
      display: flex;
      align-items: center;
      position: absolute;
      top: 89%;
      left: 0;
      z-index: 2;
      width: 32.86vw;
      height: 6vh;
      max-height: 6vh;
      box-sizing: border-box;
      padding: 0vw 1.2vw;
      background: url("../assets/images/header_left_bg.png") no-repeat;
      background-size: 100%;
      background-position: bottom;

      .message-item {
        //flex: 1;
        font-size: 1rem;
        color: #fff;
        display: flex;
        align-items: center;
        padding: 0 1.19rem 0 0.25rem;
        margin-bottom: 0.65rem;
        //overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        .risk_count {
          border: 2px solid #a35d5c;
          padding: 0px 6px;
          box-sizing: border-box;
          border-radius: 5px;
          background-color: rgba(147, 86, 89, 0.5);
          line-height: 1.05rem;
          font-weight: normal;
          margin-top: 2px;
          padding-bottom: 1px;
        }

        i {
          display: block;
          width: 1.67vw;
          height: 1.67vw;
          background-repeat: no-repeat;
          background-size: contain;
          margin-right: 0.56rem;
          flex-shrink: 0;
        }

        .risk {
          background-image: url("../assets/images/风险提醒1.png");
        }

        .weather {
          background-image: url("../assets/images/天气提醒1.png");
        }

        .report {
          background-image: url("../assets/images/专报提醒.png");
        }

        .animation {
          animation: fadenum 1s infinite;
        }

        @keyframes fadenum {

          /*设置内容由显示变为隐藏*/
          0% {
            opacity: 1;
          }

          50% {
            opacity: 0.3;
          }

          100% {
            opacity: 1;
          }
        }

        span {
          white-space: nowrap;
          //overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .aside {
    display: flex;
    flex-direction: column;
    width: 6.38rem;
    max-width: 102px;
    height: 100%;
    overflow: hidden;

    .nav {
      background: #2d74f5 url("../assets/images/设备背景.png") no-repeat;
      // background-size: 100% 100%;
      background-position: 0 100%;
      height: 100%;

      >.el-scrollbar {
        >.el-scrollbar__wrap {
          overflow-x: hidden;

          >.el-scrollbar__view {
            .menu {
              margin: 0;
              padding: 0;

              li {
                list-style: none;
                text-align: center;
                font-size: 1rem;
                color: #fff;
                height: 5.69rem;
                max-height: 91px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                cursor: pointer;

                //margin-bottom: 0.2rem;
                i {
                  display: block;
                  width: 1.75rem;
                  height: 1.75rem;
                  // max-width: 26px;
                  // max-height: 26px;
                  background-size: contain !important;
                  margin: 0 auto 0.44rem;
                }
              }

              li.active {
                background: url("../assets/images/选中状态.png") no-repeat;
                background-size: 80%;
                background-position: center;
                font-weight: 500;
              }

              li:hover {
                background: url("../assets/images/选中状态.png") no-repeat;
                background-size: 80%;
                background-position: center;
                // margin-bottom: 2px;
              }
            }
          }
        }

        >.is-vertical {
          display: none;
        }
      }
    }
  }

  .right-bottom-tool {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 50%;
    top: 4.64vw;
    z-index: 9;
    transform: translateX(-50%);
    width: 25.57vw;
    height: 3.49vw;
    background: linear-gradient(90deg,
        rgba(8, 72, 128, 0) 0%,
        #084880 52%,
        rgba(8, 72, 128, 0) 100%);
    // width: 17.24vw;
    // height: 8vh;
    // background: url("../assets/images/矩形.png") no-repeat;
    // background-size: 100% 100%;

    .reset_index {
      height: 1.5rem !important;
      width: 1.5rem !important;
    }

    .image {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 2.76vw;
      height: 2.76vw;
      cursor: pointer;

      img {
        width: 1.72vw;
      }

      margin-left: 1.51vw;
    }

    //.image:nth-child(2) {
    //  margin: 0vw 1.51vw;
    //}

    .image.active {
      background: url("../assets/images/选择.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .center-bottom-tool {
    display: flex;
    justify-content: center;
    // align-items: center;
    position: fixed;
    left: 50%;
    bottom: 0vw;
    z-index: 9;
    transform: translateX(-50%);
    width: 100vw;
    height: 9vh;
    padding: 0 26.82vw;
    box-sizing: border-box;
    // padding: 0.7vw 0px 0px;
    box-sizing: border-box;
    background: url("../assets/images/底部.png") no-repeat;
    background-size: 100% auto;
    background-position: left bottom;

    .center-control {
      margin-top: 0.6vw;
      width: 1.88vw;
      height: 1.88vw;
      cursor: pointer;
    }

    .center-box::-webkit-scrollbar {
      display: none;
    }

    .center-box {
      flex: 1;
      overflow: hidden;
      overflow-x: auto;

      .content-wrap {
        display: flex;
      }

      .nav-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 3.6vw;
        padding: 0.3vh 0.36vw;
        margin: 0px 0.9vw;
        flex-shrink: 0;
        font-size: 0.83vw;
        color: #ffffff;
        cursor: pointer;

        img {
          width: 1.72vw;
        }
      }

      .nav-item.active {
        background: url("../assets/images/选择.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .container {
    flex: 1;
    display: flex;
    // flex-direction: column;
    overflow: hidden;
    position: relative;

    .main {
      flex: 1;
      position: relative;

      #map {
        width: 100%;
        height: 100%;
        background-color: rgba(13, 66, 112, 1);
      }
    }

    .logo1 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 7.04vw;
      bottom: 0.52vw;

      img {
        width: 1.46vw;
      }

      span {
        margin-left: 0.52vw;
        font-size: 0.73vw;
        color: #999999;
      }
    }
  }

  @keyframes metro-alert-blink {

    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0.35;
    }
  }

  .metro-swiper {
    display: flex;
    align-items: center;
    position: absolute;
    top: 12%;
    left: 0;
    width: 29vw;
    z-index: 5;
    overflow: hidden;
    margin-left: 1vw;

    img {
      flex-shrink: 0;
      width: 1.2vw;
      height: 1.2vw;
      margin-right: 0.5vw;
      object-fit: contain;
      animation: metro-alert-blink 1s ease-in-out infinite;
    }

    .metro-swiper-viewport {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
    }

    .metro-swiper-track {
      display: inline-flex;
      animation-name: metro-marquee;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }

    .metro-swiper-item {
      padding-right: 4vw;
      white-space: nowrap;
      font-size: 0.83vw;
      color: #fff;
    }
  }

  @keyframes metro-marquee {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-50%);
    }
  }

  .mark {
    pointer-events: none;
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: 2;
    background: url("../assets/images/mark.png");
    background-size: 100% 100%;
  }

  .el-dialog__wrapper {
    .el-dialog {
      width: 73.38rem;
      height: 73vh;
      margin-top: 17vh;
      border-radius: 0.75rem;
      display: flex;
      flex-direction: column;
      background: #2c6aa3;
      box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.5);
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.5);

      // background: #165184;
      // box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.5),
      //   inset 0px 0px 77px 0px rgba(100, 184, 248, 1);
      // border-radius: 12px;
      // border: 1px solid;
      // border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1;
      .el-icon-close:before {
        color: #fff;
      }

      .el-icon-close:hover {
        transform: scale(1.15);
      }

      .el-dialog__header {
        border-radius: 0.75rem 0.75rem 0 0;
        padding: 1.25rem 1.88rem 1.25rem;
        cursor: move;
        background: linear-gradient(90deg,
            rgba(111, 179, 221, 0.02) 0%,
            #68b1ff 50%,
            rgba(60, 124, 184, 0) 100%);

        .el-dialog__title {
          font-size: 1.13rem;
          font-weight: 600;
          color: #fff;
        }

        .el-dialog__headerbtn {
          font-size: 1rem;
          top: 1.25rem;
          right: 1.25rem;

          .el-dialog__close {
            color: #333333;
          }
        }
      }

      .el-dialog__body {
        padding: 1.19rem 1.31rem;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }

    .warn {
      height: 40vh;
      left: 69vw;
      margin: 0px;
    }

    .hdsk {
      height: 55vh;
      margin-top: 25vh !important;
    }

    .wtlp {
      height: 55vh;
      margin-top: 25vh !important;
    }

    .sdrf {
      height: 30vh;
      margin-top: 60vh !important;
      margin-left: 60vh !important;
    }
  }

  .overlayerRef {
    display: inline-block;
    height: 1.93vw;
    padding: 0vw 0.52vw;
    background: #ffffff;
    box-shadow: 0vw 0vw 0.47vw 0vw rgba(184, 184, 184, 0.5);
    border-radius: 0.26vw;
    font-size: 0.83vw;
    color: #8d8d8d;
    line-height: 1.93vw;
  }
}

@media screen and(min-width: 1920px) {
  .home {
    .header {
      .tool {
        span {
          font-size: 16px;
        }
      }

      .logo {
        font-size: 36px;
      }

      .message {
        .message-item {
          font-size: 16px;
        }
      }

      .header-right {
        .now {
          font-size: 16px;

          strong {
            font-size: 22px;
          }
        }
      }
    }

    .container {
      .aside {
        .nav {
          >.el-scrollbar {
            >.el-scrollbar__wrap {
              >.el-scrollbar__view {
                .menu {
                  li {
                    position: relative;
                    font-size: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.count {
  position: absolute;
  top: 0.16vw;
  right: 0.16vw;
  background-color: #f56c6c;
  border-radius: 0.32vw;
  color: #fff;
  display: inline-block;
  font-size: 0.43vw;
  height: 0.94vw;
  line-height: 0.94vw;
  padding: 0 0.31vw;
  text-align: center;
  white-space: nowrap;
}

.box {
  position: fixed;
  // position: absolute;
  right: 1.31rem;
  background: #ffffff;
  box-shadow: 0rem 0.13rem 1.13rem 0rem rgba(139, 157, 189, 0.35);
  border-radius: 0.75rem;
  min-width: 31.81rem;

  .tabs {
    display: flex;
    position: absolute;
    top: -1.95rem;
    left: 0;
    z-index: 99;

    .tab {
      background: url("../assets/images/矩形-白色.png") no-repeat;
      background-size: 100% 100%;
      font-size: 1.13rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #999;
      text-align: center;
      padding: 1.6rem 2.3rem;

      span {
        cursor: pointer;
      }
    }

    .tab.active {
      background: url("../assets/images/矩形-蓝色.png") no-repeat;
      background-size: 100% 100%;
      color: #fff;
    }

    .tab:not(:first-child) {
      margin-left: -2rem;
    }
  }

  .close {
    position: absolute;
    right: 1.25rem;
    top: 5%;

    img {
      width: 0.75rem;
      cursor: pointer;
    }
  }

  .p-time {
    position: absolute;
    right: 2.5rem;
    top: 5.5%;
    font-size: 0.75rem;
    color: #666666;
  }
}

.select-map {
  // width: 100px;
  color: #fff;

  .title {
    padding-left: 0.52vw;
    font-weight: 700;
  }

  .item {
    display: flex;
    padding: 0vw 0.52vw 0vw 0.52vw;
    height: 1.56vw;
    text-rendering: auto;
    font-size: 0.63vw;
    line-height: 1.56vw;
    text-align: center;

    &:hover {
      cursor: pointer;
    }

    span {
      margin-left: 0.52vw;
      font-size: 0.63vw;
    }

    span:nth-child(1) {
      display: inline-block;
      width: 10px;
    }

    span:nth-child(2) {
      flex: 1;
    }
  }
}

.ol-zoom {
  display: none !important;
}

.blueLayer {
  filter: grayscale(98%) invert(100%) hue-rotate(180deg) saturate(100%) brightness(70%) contrast(90%);
}

.runbir-tooltip {
  color: #fff;
}

.runbir-draw-delete {
  color: #fff;
}

.obt-ptime {
  position: fixed;
  z-index: 9;
  top: 18vh;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 0.65vw;
  opacity: 0.8;
}

// 卡片样式
.card-box {
  position: fixed;
  width: 25.73vw;
  height: 23.5vh;
  z-index: 9;
  border-radius: 10px;
  /**蓝色地图 */
  background: rgba(12, 80, 146, 0.6);
  /**暗黑地图 */
  // background: linear-gradient(
  //   180deg,
  //   rgba(32, 121, 197, 0.8) 0%,
  //   rgba(8, 38, 48, 1) 100%
  // );
  /* 使用 ::before 伪元素创建渐变边框 */
  box-shadow: 0 0 0 1px rgba(109, 179, 254, 0.7),
    0 0 0 1px rgba(255, 255, 255, 0.7);

  .line {
    position: absolute;
    left: 0;
    top: -0.08vw;
    width: 0.83vw;
    height: 0.16vw;
    background: #8ee8ff;
    display: none;
  }

  .line1 {
    left: auto;
    right: 0;
    display: none;
  }

  .tabs {
    display: flex;
    align-items: center;
    flex: 1;
    position: relative;
    z-index: 9;
    height: 2.5vw;
    margin: 0 0.68vw 0 0.99vw;
    background: url("../assets/images/小标题样式.png") no-repeat;
    background-size: 100% auto;
    background-position: left bottom;
    cursor: move;

    .tab {
      display: flex;
      align-items: center;
      margin-right: 1.3vw;
      color: #fff;
      cursor: pointer;

      .name {
        display: flex;
        align-items: center;
        font-size: 0.89vw;
      }
    }

    .tab.active {
      .name {
        flex-shrink: 0;

        &::before {
          position: relative;
          display: inline-block;
          content: "";
          width: 0.83vw;
          height: 0.83vw;
          margin-right: 0.42vw;
          background: url("../assets/images/星.png") no-repeat;
          background-size: 100%;
        }
      }
    }
  }

  .card-close {
    margin-top: 0.6vw;
    text-align: center;
    position: absolute;
    right: 0.68vw;
    top: 0px;
    z-index: 9;
    cursor: pointer;

    img {
      width: 0.5vw;
    }

    &:hover {
      transform: scale(1.1);
    }
  }
}

.sdrf {
  position: relative;
  height: 180px;
  background: linear-gradient(180deg, rgba(32, 121, 197, 0.8) 0%, #082630 100%);

  .sdrf-main {
    height: 100%;
  }
}

.lonlatInfo {
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(255, 255, 255, 1);
  color: #000;
  z-index: 999;
}

.route-control-panel {
  position: absolute;
  top: 17vh;
  left: 27.5vw;
  z-index: 10;

  .route-list {
    display: flex;
    flex-direction: column;
    gap: 1vh;
  }

  .route-btn {
    // min-width: 11vw;
    padding: 0.6vh 0.5vw;
    border: none;
    border-radius: 999px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    color: #fff;
    font-size: 0.85vw;
    cursor: pointer;
    outline: none;
    opacity: 0.4;

    &.active {
      opacity: 1;
    }
  }
}
</style>
